import {
  getPermissionsFromRolePermissions,
  createDevice,
  rephraseScheduleText,
  generateDefaultTabColumnsPreferenceReqBody,
  getSuggestedHeatmapRange,
  syncColumnStates,
  hasColumnStateChanged
} from 'common/utils/helpers';
import {
  Status,
  defaultSearchBodies,
  defaultDeviceTableSearchBody,
  defaultParameterGraphAggregateBody,
  DEVICES_PAGE_TAB,
  DEFAULT_TAB_FILTER,
  USER_PREFERENCE_SETS,
  PRODUCT_TYPES
} from 'common/utils/constants';
import { patchDevice } from 'apis/PatchDevice';
import { setGain } from 'apis/SetGain';
import { searchDevices, searchBundles, searchDevicesIds, mapDeviceSearchResult } from 'apis/SearchDevices';
import { getDevice } from 'apis/GetDevice';
import { getParameterSchema } from 'apis/GetParameterSchema';
import { softwareUpdate } from 'apis/SoftwareUpdate';
import { softwareUpdateStatus } from 'apis/SoftwareUpdateStatus';
import { getSoftwareVersions } from 'apis/GetSoftwareVersions';
import { getDefaultSWVersion } from 'apis/GetDefaultSWVersion';
import { updateDefaultSWVersion } from 'apis/UpdateDefaultSWVersion';
import { getSupportedCommissioningSoftwareVersions } from 'apis/CommissioningManager';
import ActionTypes from 'redux/ActionTypes';
import { bulkSoftwareUpdate } from 'apis/BulkSoftwareUpdate';
import { softwareUpload } from 'apis/SoftwareUpload';
import { deleteSoftware } from 'apis/DeleteSoftware';
import { getActions } from 'apis/GetActions';
import { fetchAlarms } from 'apis/FetchAlarms';
import { setLockUnlock } from 'apis/SetLockUnlock';
import { createBundle, getBundle, patchBundle, deleteBundle } from 'apis/BundleManager';
import { checkRaster, startRaster } from 'apis/Raster';
import { setWifi } from 'apis/SetWifi';
import { blinkDeviceLED } from 'apis/BlinkDeviceLED';
import { getPermissions } from 'apis/Permissions';
import { getAvailablePmCounters, getAvailableCmCounters } from 'apis/GetAvailableCounters';
import {
  fetchHistoricalEventLogs,
  retrieveEventLog,
  fetchRuntimeStatus,
  fetchLiveEventLogs,
  pathcDeviceById
} from 'apis/FetchEventLogs';
import { getRoleUsers, getRoleList, getAllPermissionList } from 'apis/RolesAndPermissionManager';
import { getUsers } from 'apis/GetUsers';
import { createRole, updateRole, deleteRole } from 'apis/RolesAndPermissionManager';
import {
  createDeviceGroup,
  updateDeviceGroup,
  deleteDeviceGroup,
  getAllUserDeviceGroups,
  undoDeviceGroupDeletion,
  getAllUserDevicePolygons,
  duplicateDeviceGroupPolygon,
  createDeviceGroupPolygon,
  updateDeviceGroupPolygon,
  importDeviceGroupPolygon,
  exportDeviceGroupPolygon,
  sortUserDevicePolygons
} from 'apis/DeviceGroupsManagement';
import { getRasterInfo } from 'apis/commissioningApis/GetRasterInfo';
import { initiateCommissioning } from 'apis/commissioningApis/InitiateCommissioning';
import { terminateCommissionOp } from 'apis/commissioningApis/TerminateCommissionOp';
import { setActiveBeam, setServicesActiveBeam } from 'apis/commissioningApis/SetActiveBeam';
import { getCommissioningActions } from '../apis/GetCommissioningActions';
import { getFeatureToggle } from 'apis/swManagerApis/GetFeatureToggle';
import { patchFeatureToggle } from 'apis/swManagerApis/PatchFeatureToggle';
import { getAutoUpdateSchedule } from 'apis/swManagerApis/GetAutoUpdateSchedule';
import { postAutoUpdateSchedule } from 'apis/swManagerApis/PostAutoUpdateSchedule';
import { getProductTypes } from 'apis/GetProductTypes';
import { postDevicesAggregate } from 'apis/DevicesAggregate';
import { getRasterRecord } from 'apis/GetRasterRecord';
import { getRasterRecordsForDevice } from 'apis/GetRasterRecordsForDevice';
import { getLatestHeatmapFromDevice } from 'apis/GetLatestHeatmapFromDevice';
import { getFactoryProtectedDevices } from 'apis/swManagerApis/GetFactoryProtectedDevices';
import { getProtectedDevices } from 'apis/swManagerApis/GetProtectedDevices';
import { addFactoryProtectedDevices } from 'apis/swManagerApis/AddFactoryProtectedDevice';
import { deleteFactoryProtectedDevice } from 'apis/swManagerApis/DeleteFactoryProtectedDevice';
import { deleteProtectedDevice } from 'apis/swManagerApis/DeleteProtectedDevice';
import { addProtectedDevice } from 'apis/swManagerApis/AddProtectedDevice';
import { persistRasterRecord } from 'apis/PatchRasterRecord';
import { initiateRaster } from 'apis/InitiateRaster';
import { getTwoHopAlignmentStatusInstances } from 'apis/twoHopApis/GetTwoHopAlignmentStatusInstances';
import { postTwoHopAlignmentBeamInfo } from 'apis/twoHopApis/PostTwoHopAlignmentBeamInfo';
import { getTwoHopAlignmentBeamInfo } from 'apis/twoHopApis/GetTwoHopAlignmentBeamInfo';
import { cancelTwoHopAlignment } from 'apis/twoHopApis/CancelTwoHopAlignment';
import {
  createDeviceSetsSelector,
  selectActiveTabName,
  selectDeviceGroups,
  selectSelectedDeviceGroupName,
  selectUserPreferences
} from 'redux/selectors';
import { getRasterSettings } from 'apis/GetRasterSettings';
import {
  createUserPreference,
  getUserPreferenceList,
  selectUserPreferenceList,
  selectDefaultUserPreference,
  selectUserPreference,
  patchUserPreference
} from './UserPreferences';
import { getParsedFilterSet } from '../components/features/FiltersBar/utils';
import { getAllBeamTables } from 'apis/swManagerApis/GetAllBeamTables';
import { deleteBeamTable } from 'apis/swManagerApis/DeleteBeamTable';
import { putUploadBeamTable } from 'apis/swManagerApis/PutUploadBeamTable';

export function setPage(page) {
  return {
    type: ActionTypes.SET_PAGE,
    page: page
  };
}

export function setUserInfo(userInfo) {
  return {
    type: ActionTypes.SET_USER_INFO,
    userInfo: userInfo
  };
}

export function setUserRoles(rolePermissions) {
  return {
    type: ActionTypes.SET_USER_ROLES,
    roles: rolePermissions
  };
}

export function setUserPermissions(permissions) {
  return {
    type: ActionTypes.SET_USER_PERMISSIONS,
    permissions: permissions
  };
}

export function requestLogin() {
  return updateStatus('auth0', Status.PENDING);
}

export function recievedLogin() {
  return updateStatus('auth0', Status.SUCCESS);
}

export function errorLogin() {
  return updateStatus('auth0', Status.FAILURE);
}

export function logout() {
  return updateStatus('auth0', Status.NONE);
}

export function handleAuthentication() {
  return (dispatch, getState, { auth }) => {
    auth
      .handleAuthentication()
      .then(() =>
        getPermissions()
          .then((result) => {
            let permissionsList = getPermissionsFromRolePermissions(result);

            dispatch(setUserRoles(result));
            dispatch(setUserPermissions(permissionsList));

            localStorage.setItem('permissions', JSON.stringify(permissionsList));
            localStorage.setItem('roles', JSON.stringify(result));
            dispatch(recievedLogin());
          })
          .catch((error) => {
            if (process.env.NODE_ENV !== 'production') {
              console.error(error);
            }
          })
      )
      .catch(() => {
        dispatch(errorLogin());
      });
  };
}

export function setScrollReactTableVisisbility(visibility) {
  return {
    type: ActionTypes.SET_SCROLL_REACT_TABLE_VISIBILITY,
    setVisibility: visibility
  };
}

export function setMapSize(status) {
  return {
    type: ActionTypes.SET_MAP_SIZE,
    setSize: status
  };
}

export function setBlockedLayerShow(payload) {
  return {
    type: ActionTypes.SET_BLOCKED_LAYER_SHOW,
    payload
  };
}

export const setActivePolygon = (polygonId) => (dispatch) => {
  dispatch({
    type: ActionTypes.SET_ACTIVE_POLYGON,
    setPolygonId: polygonId
  });

  return Promise.resolve();
};

export const setDefaultActivePolygon = (activePolygonId, isDefaultPolygonInitialised) => (dispatch) => {
  dispatch({
    type: ActionTypes.SET_DEFAULT_ACTIVE_POLYGON,
    payload: {
      activePolygonId,
      isDefaultPolygonInitialised
    }
  });

  return Promise.resolve();
};

export function setSRTLastScroll(tableId, scrollDepth) {
  return {
    type: ActionTypes.UI_SET_SRT_LASTSCROLL,
    tableId: tableId,
    scrollDepth: scrollDepth
  };
}

export function updateDevicesPageActiveTab(tab) {
  return {
    type: ActionTypes.UPDATE_DEVICES_PAGE_ACTIVE_TAB,
    tab
  };
}

// update initiailRequestSent to true to avoid loading when jump back from other pages
export function updateTabInitialRequest(tab) {
  let type;
  if (tab === DEVICES_PAGE_TAB.pivot) {
    type = ActionTypes.UPDATE_DEVICE_SETS_INITIAL_REQUEST_PIVOT_TAB;
  } else if (tab === DEVICES_PAGE_TAB.echo) {
    type = ActionTypes.UPDATE_DEVICE_SETS_INITIAL_REQUEST_ECHO_TAB;
  } else {
    type = ActionTypes.UPDATE_DEVICE_SETS_INITIAL_REQUEST_ALL_TAB;
  }
  return {
    type
  };
}

export function openTempChartModal(isOpen) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_CONFIG_CHART_MODAL_OPEN,
    isOpen
  };
}

export function updateSingleDevicePageSwVersionModal(isOpen) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_SET_SW_VERSION_MODAL_OPEN,
    isOpen
  };
}

export function updateDevicesPageBulkActionModal(isOpen) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_SET_BULK_ACTION_MODAL_OPEN,
    isOpen
  };
}

export function updateDevicesPageBulkViewModal(isOpen) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_SET_BULK_VIEW_MODAL_OPEN,
    isOpen
  };
}

export function updateDevicesPageBulkCreateListModal(isOpen) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_SET_BULK_CREATE_LIST_MODAL_OPEN,
    isOpen
  };
}

export function updateDevicesPageBulkManageListsModal(isOpen) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_SET_BULK_MANAGE_LISTS_MODAL_OPEN,
    isOpen
  };
}

export function updateDevicesPageManageColumnsModal(isOpen) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_SET_MANAGE_COLUMNS_MODAL_OPEN,
    isOpen
  };
}

export function updateDevicesPageViewDevicesListModal(isOpen) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_SET_VIEW_DEVICES_LIST_MODAL_OPEN,
    isOpen
  };
}

export function updateDevicesPageSwUpdateStatusModal(isOpen) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_SET_SW_UPDATE_STATUS_MODAL_OPEN,
    isOpen
  };
}

export function updateDevicesPageSelectedDeviceGroupName(deviceGroupName) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_UPDATE_SELECTED_DEVICE_GROUP_NAME,
    selectedDeviceGroupName: deviceGroupName
  };
}

export function setIsDefaultDeviceGroupInitialized(isDefaultDeviceGroupInitialized) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_SET_IS_DEFAULT_DEVICE_GROUP_INITIALIZED,
    isDefaultDeviceGroupInitialized
  };
}

export function setStatusNotification(statusNotification) {
  return {
    type: ActionTypes.SET_STATUS_NOTIFICATION,
    statusNotification
  };
}

export function updateStatusNotification(statusNotification) {
  return {
    type: ActionTypes.UPDATE_STATUS_NOTIFICATION,
    statusNotification
  };
}

export function deleteStatusNotification(statusNotification) {
  return {
    type: ActionTypes.DELETE_STATUS_NOTIFICATION,
    statusNotification
  };
}

export function addToastNotification(toastNotification = {}) {
  return {
    type: ActionTypes.ADD_TOAST_NOTIFICATION,
    toastNotification
  };
}

export function deleteToastNotification(toastNotificationId) {
  return {
    type: ActionTypes.DELETE_TOAST_NOTIFICATION,
    toastNotificationId
  };
}

export function clearToastNotifications() {
  return {
    type: ActionTypes.CLEAR_TOAST_NOTIFICATIONS
  };
}

//This function is removed because it relies on the old twin/bundles dictionary/cache.
//The optimization rework removed the cache and this function has been doing nothing.
//Heavy reliance on the the new cache is frowned upon
//Is this functionality essential?

// export function updateLocalFilteredDevices(devicesIds = []) {
//   let originalDevices = store.getState().data.devices.devicesDictionary;
//   let originalBundles = store.getState().data.filteredDevices.original.bundles;
//   let newLocalDevices = [];

//   devicesIds.forEach((deviceId) => {
//     if (originalDevices[deviceId]) newLocalDevices.push(originalDevices[deviceId]);
//     if (originalBundles[deviceId]) newLocalDevices.push(originalBundles[deviceId]);
//   });
//   return {
//     type: ActionTypes.UPDATE_LOCAL_FILTERED_DEVICES,
//     newLocalDevices
//   };
// }

export function updateSingleDevicePageSelectedDevice(device) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_SELECTED_DEVICE,
    device: device
  };
}

export function updateMapListViewSwitch(targetTab, mapListViewSwitchState) {
  let type;
  if (targetTab === DEVICES_PAGE_TAB.pivot) {
    type = ActionTypes.UI_DEVICESPAGE_MAPLISTVIEW_SWITCH_STATUS_PIVOT_TAB;
  } else if (targetTab === DEVICES_PAGE_TAB.echo) {
    type = ActionTypes.UI_DEVICESPAGE_MAPLISTVIEW_SWITCH_STATUS_ECHO_TAB;
  } else {
    type = ActionTypes.UI_DEVICESPAGE_MAPLISTVIEW_SWITCH_STATUS_ALL_TAB;
  }
  return {
    type,
    mapListViewSwitchState: mapListViewSwitchState
  };
}

export function updateSelectListNotification(show) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_SHOW_SELECT_LIST_NOTIFICATION,
    show
  };
}

export function updateAlarmSort(sortBy) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_SORT_ALARMS,
    sortBy: sortBy
  };
}

export function updateConfigHistoryViewSwitch(deviceId, configHisotryViewSwitchState) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_CONFIGHISTORYVIEW_SWITCH_STATE,
    deviceId,
    configHisotryViewSwitchState
  };
}

export function updateConfigHistoryKpiCheckboxItems(deviceId, kpisCheckboxItems) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_KPISCHECKBOXITEMS,
    deviceId,
    kpisCheckboxItems
  };
}

export function updateConfigHistoryParamCheckboxItems(deviceId, paramCheckboxItems) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_PARAMCHECKBOXITEMS,
    deviceId,
    paramCheckboxItems
  };
}

export function updateConfigHistoryLocalCountersData(deviceId, localCountersData) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_LOCALCOUNTERSDATA,
    deviceId,
    localCountersData
  };
}

export function updateConfigHistorySelectedCounters(deviceId, selectedCounters) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_SELECTEDCOUNTERS,
    deviceId,
    selectedCounters
  };
}

export function updateConfigHistorySavedDataConfigs(deviceId, savedDataConfigs) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_SAVEDDATACONFIGS,
    deviceId,
    savedDataConfigs
  };
}

export function updateConfigHistorySavedChartDataConfigs(deviceId, savedChartDataConfigs) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_SAVED_CHART_DATA_CONFIGS,
    deviceId,
    savedChartDataConfigs
  };
}

/* selectMode will be an object, format:
{
    shape: none, circle, poly, etc
    bulk: whether bulk select is active, used in map + table
    allSelect: if all devices are selected, used for the check all box
}*/
export function setMapSelectMode(selectMode, activeTab) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_SET_MAP_SELECT,
    selectMode: selectMode,
    activeTab
  };
}

export function updateMapDrawings(drawnItems) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_MAP_DRAWINGS,
    mapDrawnItems: drawnItems
  };
}

export function updateLastSelection(drawnItem) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_MAP_LAST_SELECTION,
    mapDrawnItem: drawnItem
  };
}

export function updateChartSelectionsConfig(config, key) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_CHART_SELECTIONS_SAVE,
    savedSelectionsConfig: config,
    renderKey: key
  };
}

export function updateDevicesPageSelectedDeviceId(id) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_SELECT_DEVICE_ID,
    id: id
  };
}

export function updateDevicesPageExpandedBundleId(bundleId) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_EXPANDED_BUNDLE_ID,
    bundleId
  };
}

export function updateSelectedDevicesList(targetTab, selectedDevices) {
  let type;
  if (targetTab === DEVICES_PAGE_TAB.pivot) {
    type = ActionTypes.UI_DEVICESPAGE_UPDATE_SELECTED_DEVICES_LIST_PIVOT_TAB;
  } else if (targetTab === DEVICES_PAGE_TAB.echo) {
    type = ActionTypes.UI_DEVICESPAGE_UPDATE_SELECTED_DEVICES_LIST_ECHO_TAB;
  } else {
    type = ActionTypes.UI_DEVICESPAGE_UPDATE_SELECTED_DEVICES_LIST_ALL_TAB;
  }
  return {
    type,
    selectedDevices: selectedDevices
  };
}

export function clearSelectedDevicesList(targetTab) {
  let type;
  if (targetTab === DEVICES_PAGE_TAB.pivot) {
    type = ActionTypes.UI_DEVICESPAGE_CLEAR_DEVICE_INDEX_LIST_PIVOT_TAB;
  } else if (targetTab === DEVICES_PAGE_TAB.echo) {
    type = ActionTypes.UI_DEVICESPAGE_CLEAR_DEVICE_INDEX_LIST_ECHO_TAB;
  } else {
    type = ActionTypes.UI_DEVICESPAGE_CLEAR_DEVICE_INDEX_LIST_ALL_TAB;
  }
  return {
    type
  };
}

export function updateSelectedDevicesData(targetTab, selectedDictionary) {
  let type;
  if (targetTab === DEVICES_PAGE_TAB.pivot) {
    type = ActionTypes.UPDATE_SELECTED_DEVICES_DATA_PIVOT_TAB;
  } else if (targetTab === DEVICES_PAGE_TAB.echo) {
    type = ActionTypes.UPDATE_SELECTED_DEVICES_DATA_ECHO_TAB;
  } else {
    type = ActionTypes.UPDATE_SELECTED_DEVICES_DATA_ALL_TAB;
  }
  return {
    type,
    selectedDevicesData: selectedDictionary
  };
}

export function removeSelectedDevicesData(targetTab, deviceKey) {
  let type;
  if (targetTab === DEVICES_PAGE_TAB.pivot) {
    type = ActionTypes.REMOVE_SELECTED_DEVICE_DATA_PIVOT_TAB;
  } else if (targetTab === DEVICES_PAGE_TAB.echo) {
    type = ActionTypes.REMOVE_SELECTED_DEVICE_DATA_ECHO_TAB;
  } else {
    type = ActionTypes.REMOVE_SELECTED_DEVICE_DATA_ALL_TAB;
  }
  return {
    type,
    deviceKey: deviceKey
  };
}

export function clearSelectedDevicesData(targetTab) {
  let type;
  if (targetTab === DEVICES_PAGE_TAB.pivot) {
    type = ActionTypes.CLEAR_SELECTED_DEVICES_DATA_PIVOT_TAB;
  } else if (targetTab === DEVICES_PAGE_TAB.echo) {
    type = ActionTypes.CLEAR_SELECTED_DEVICES_DATA_ECHO_TAB;
  } else {
    type = ActionTypes.CLEAR_SELECTED_DEVICES_DATA_ALL_TAB;
  }

  return {
    type
  };
}

export function updateDevicesPageMapViewport({ center, zoom }) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_MAPLISTVIEW_MAP_VIEWPORT,
    center,
    zoom
  };
}

function updateDeviceParameterSchema(schema) {
  return {
    type: ActionTypes.DEVICE_PARAMETER_SCHEMA,
    schema: schema
  };
}

export function updateStatus(name, status) {
  return {
    type: ActionTypes.UPDATE_STATUS,
    name: name,
    status: status
  };
}

export function updateBundleStatus(name, status, e) {
  if (e) console.log('network error: ', e);
  return {
    type: ActionTypes.UPDATE_STATUS_BUNDLE,
    name: name,
    status: status
  };
}

export function setSelectedParameters(targetTab, parameters) {
  let type;
  switch (targetTab) {
    case DEVICES_PAGE_TAB.pivot:
      type = ActionTypes.UI_DEVICESPAGE_SET_SELECTED_PARAMETERS_PIVOT_TAB;
      break;
    case DEVICES_PAGE_TAB.echo:
      type = ActionTypes.UI_DEVICESPAGE_SET_SELECTED_PARAMETERS_ECHO_TAB;
      break;
    case DEVICES_PAGE_TAB.all:
      type = ActionTypes.UI_DEVICESPAGE_SET_SELECTED_PARAMETERS_ALL_TAB;
      break;
    default:
      break;
  }

  return {
    type,
    parameters: parameters
  };
}

export function updateDevicesDictionaries(devices, bundles) {
  return (dispatch, getState) => {
    dispatch(updateDevicesDictionary(devices));
    dispatch(updateBundlesDictionary(bundles));
  };
}

export function updateDevicesDictionary(devices, shouldFormat) {
  let localDeviceDictionary = {};

  if (shouldFormat) {
    devices.forEach((d) => {
      localDeviceDictionary[d.id] = d;
    });
  } else localDeviceDictionary = devices;

  return {
    type: ActionTypes.UPDATE_DEVICES_DICTIONARY,
    localDeviceDictionary: localDeviceDictionary
  };
}

export function updateBundlesDictionary(bundlesDictionary) {
  return {
    type: ActionTypes.UPDATE_BUNDLES_DICTIONARY,
    localBundlesDictionary: bundlesDictionary
  };
}

function updateParameterGraphDeviceSet(targetTab, aggregations, filterRequestIndex) {
  // let oldRequestIndex = store.getState().data.deviceSets['parametersGraph'].filterRequestIndex;
  // if (filterRequestIndex < oldRequestIndex) return;
  let type;
  switch (targetTab) {
    case DEVICES_PAGE_TAB.pivot:
      type = ActionTypes.UPDATE_DEVICE_SETS_PARAMETERSGRAPH_PIVOT_TAB;
      break;
    case DEVICES_PAGE_TAB.echo:
      type = ActionTypes.UPDATE_DEVICE_SETS_PARAMETERSGRAPH_ECHO_TAB;
      break;
    case DEVICES_PAGE_TAB.all:
      type = ActionTypes.UPDATE_DEVICE_SETS_PARAMETERSGRAPH_ALL_TAB;
      break;
    default:
      type = ActionTypes.UPDATE_DEVICE_SETS_PARAMETERSGRAPH_PIVOT_TAB;
  }
  return {
    type,
    aggregations: aggregations,
    filterRequestIndex: filterRequestIndex
  };
}

function updateDeviceSets(
  targetTab,
  componentType,
  devices,
  bundles,
  continuationToken,
  hasMoreResults,
  filterRequestIndex,
  shouldConcat,
  polygon
) {
  const selectDeviceSets = createDeviceSetsSelector(targetTab);

  return (dispatch, getState) => {
    const state = getState();
    const deviceSets = selectDeviceSets(state);
    let actionType = null;
    let oldRequestIndex = deviceSets[componentType].filterRequestIndex;
    if (filterRequestIndex < oldRequestIndex) return;

    switch (componentType) {
      case 'deviceTable':
        devices = devices.concat(Object.values(bundles));
        switch (targetTab) {
          case DEVICES_PAGE_TAB.pivot:
            actionType = ActionTypes.UPDATE_DEVICE_SETS_DEVICETABLE_DATA_PIVOT_TAB;
            break;
          case DEVICES_PAGE_TAB.echo:
            actionType = ActionTypes.UPDATE_DEVICE_SETS_DEVICETABLE_DATA_ECHO_TAB;
            break;
          case DEVICES_PAGE_TAB.all:
            actionType = ActionTypes.UPDATE_DEVICE_SETS_DEVICETABLE_DATA_ALL_TAB;
            break;
          default:
            break;
        }
        break;
      case 'deviceMap':
        devices = devices.concat(Object.values(bundles));
        switch (targetTab) {
          case DEVICES_PAGE_TAB.pivot:
            actionType = ActionTypes.UPDATE_DEVICE_SETS_DEVICEMAP_DATA_PIVOT_TAB;
            break;
          case DEVICES_PAGE_TAB.echo:
            actionType = ActionTypes.UPDATE_DEVICE_SETS_DEVICEMAP_DATA_ECHO_TAB;
            break;
          case DEVICES_PAGE_TAB.all:
            actionType = ActionTypes.UPDATE_DEVICE_SETS_DEVICEMAP_DATA_ALL_TAB;
            break;
          default:
            break;
        }
        break;
      case 'parametersTable':
        // devices = devices.concat(Object.values(bundles));
        switch (targetTab) {
          case DEVICES_PAGE_TAB.pivot:
            actionType = ActionTypes.UPDATE_DEVICE_SETS_PARAMETERSTABLE_DATA_PIVOT_TAB;
            break;
          case DEVICES_PAGE_TAB.echo:
            actionType = ActionTypes.UPDATE_DEVICE_SETS_PARAMETERSTABLE_DATA_ECHO_TAB;
            break;
          case DEVICES_PAGE_TAB.all:
            actionType = ActionTypes.UPDATE_DEVICE_SETS_PARAMETERSTABLE_DATA_ALL_TAB;
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }

    dispatch({
      type: actionType,
      devices: devices,
      bundles: bundles,
      continuationToken: continuationToken,
      hasMoreResults: hasMoreResults,
      filterRequestIndex: filterRequestIndex,
      shouldConcat: shouldConcat,
      polygon
    });
  };
}

export function updateDevicesIds(devicesIds) {
  return {
    type: ActionTypes.UPDATE_DEVICES_IDS,
    devicesIds: devicesIds
  };
}

function updateBundles(bundles) {
  return {
    type: ActionTypes.UPDATE_BUNDLES,
    bundles: bundles
  };
}

export function updateFilteredDevices(devices, bundles, filterRequestIndex) {
  return (dispatch, getState) => {
    const state = getState();
    const deviceGroups = selectDeviceGroups(state);
    const selectedDeviceGroupName = selectSelectedDeviceGroupName(state);
    const selectedDevicesList = deviceGroups[selectedDeviceGroupName]?.devices;

    dispatch({
      type: ActionTypes.UPDATE_FILTERED_DEVICES,
      devices: devices,
      bundles: bundles,
      index: filterRequestIndex,
      selectedDeviceGroupName,
      selectedDevicesList
    });
  };
}

export function updateFilteredDevicesWithList(deviceIds) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedDeviceGroupName = selectSelectedDeviceGroupName(state);

    dispatch({
      type: ActionTypes.UPDATE_FILTERED_DEVICES_WITH_LIST,
      selectedDevicesList: deviceIds,
      selectedDeviceGroupName
    });
  };
}

export function setProvisionedRange(startDate, endDate) {
  return {
    type: ActionTypes.SET_PROVISIONED_FILTER_RANGE,
    startDate: startDate,
    endDate: endDate
  };
}

export function updateSingleDevicePagePatchValues(values) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_PATCH_VALUES,
    patchValues: values
  };
}

export function clearSingleDevicePagePatchValues() {
  return { type: ActionTypes.UI_SINGLE_DEVICE_PAGE_CLEAR_PATCH_VALUES };
}

export function setSingleDevicePageSearchBarIndex(index) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_SET_SEARCH_BAR_INDEX,
    index: index
  };
}

export function setDropModalOpen(name, openState) {
  return {
    type: ActionTypes.UI_SET_DROP_MODAL_OPEN,
    name: name,
    isOpen: openState
  };
}

export function fetchBundles(filters = {}) {
  return (dispatch, getState) => {
    let searchStatus = getState().statuses.searchBundles;

    if (searchStatus !== Status.PENDING) {
      dispatch(updateStatus('searchBundles', Status.PENDING));
      searchBundles(true)
        .then((bundles) => {
          if (bundles) {
            dispatch(updateBundles(bundles));
            dispatch(updateStatus('searchBundle', Status.SUCCESS));
          } else {
            throw Error('error retreiving bundles');
          }
        })
        .catch((error) => {
          console.log('error fetching bundles:', error);
          dispatch(updateStatus('searchBundles', Status.FAILURE));
        });
    }
  };
}

export function fetchDeviceParameterSchema(type, version) {
  return (dispatch) => {
    dispatch(updateStatus('deviceParameterSchema', Status.PENDING));
    getParameterSchema(type, version).then((schema) => {
      if (schema) {
        console.log('schema', schema);
        dispatch(updateDeviceParameterSchema(schema));
        dispatch(updateStatus('deviceParameterSchema', Status.SUCCESS));
      } else {
        console.log('fetchDeviceParameterSchema failed');
        dispatch(updateStatus('deviceParameterSchema', Status.FAILURE));
      }
    });
  };
}
export function handleMapListViewSearchQuery(searchString, devices) {
  return {
    type: ActionTypes.HANDLE_MAPLISTVIEW_SEARCH_QUERY,
    mapListViewSearchQuery: searchString,
    mapListViewDevices: devices
  };
}

function saveDeviceToHistory(id, parameters) {
  return {
    type: ActionTypes.SAVE_DEVICE_TO_HISTORY,
    id: id,
    parameters: parameters.parameters,
    device: parameters
  };
}

export function setJuanStyle(juan) {
  return {
    type: ActionTypes.SET_JUAN_STYLE,
    juan: juan
  };
}

export function setConsolePageSize(size) {
  return {
    type: ActionTypes.SET_CONSOLE_PAGE_SIZE,
    size
  };
}

export function setConsolePageClass(className) {
  return {
    type: ActionTypes.SET_CONSOLE_PAGE_CLASS,
    className
  };
}

export function patchDeviceParameters(id, parameters, lastValues, fail_cb = null, success_cb = null) {
  return (dispatch) => {
    dispatch(updateStatus('PATCH-' + id, Status.PENDING));

    if (!parameters?.tags?.userLabel) {
      dispatch(saveDeviceToHistory(id, lastValues));
    }

    patchDevice(id, parameters)
      .then((result) => {
        console.log('Patch Device Action Result:', result);

        if (result.output && result.output === 'timeout') {
          throw new Error('timeout');
        }
        if (result.runtimeStatus === 'Failed') {
          console.log('PatchDevice failed. Result:', result);
          throw new Error('');
          //TODO update some sort of error code?
        }

        if (result.isOfflineDevice) {
          //special field added in patchDevice() for offline responses from IoT hub
          dispatch(updateStatus('PATCH-' + id, Status.SUCCESS));
          dispatch(getSingleDevice(id));
          if (success_cb) success_cb();
        } else if (result.runtimeStatus === 'Completed') {
          dispatch(updateStatus('PATCH-PARAMS-' + id, result.output));
          dispatch(updateStatus('PATCH-' + id, Status.SUCCESS));
          dispatch(getSingleDevice(id));
          if (success_cb) success_cb();
        } else {
          console.log('Unexpected runtimeStatus. Result:', result);
          throw new Error('');
        }
      })
      .catch((error) => {
        dispatch(updateStatus('PATCH-' + id, Status.FAILURE));
        if (fail_cb) {
          fail_cb(error && error.message ? error.message : 'unknown', parameters);
        }
      });
  };
}

export function setDeviceGain(id, parameters, fail_cb = null) {
  return (dispatch) => {
    dispatch(updateStatus('SETGAIN-' + id, Status.PENDING));
    setGain(id, parameters)
      .then((result) => {
        console.log('Set Device Gain Action Result:', result);

        if (result.output && result.output === 'timeout') {
          throw new Error('timeout');
        }
        if (result.runtimeStatus === 'Failed') {
          console.log('Set Device Gain failed. Result:', result);
          throw new Error('');
          //TODO update some sort of error code?
        }

        if (result.isOfflineDevice) {
          //special field added in patchDevice() for offline responses from IoT hub
          dispatch(updateStatus('SETGAIN-' + id, Status.SUCCESS));
          dispatch(getSingleDevice(id));
        } else if (result.runtimeStatus === 'Completed') {
          dispatch(updateStatus('SETGAIN-PARAMS-' + id, result.output));
          dispatch(updateStatus('SETGAIN-' + id, Status.SUCCESS));
          dispatch(getSingleDevice(id));
        } else {
          console.log('Unexpected runtimeStatus. Result:', result);
          throw new Error('');
        }
      })
      .catch((error) => {
        dispatch(updateStatus('SETGAIN-' + id, Status.FAILURE));
        if (fail_cb) {
          fail_cb(error && error.message ? error.message : 'unknown');
        }
      });
  };
}

export function getRawSingleDevice(id, cb = null) {
  return (dispatch) => {
    dispatch(updateStatus('GETRAW-' + id, Status.PENDING));
    getDevice(id)
      .then((result) => {
        if (result == null) {
          //something went wrong, how do we handle?
          throw Error('unexpected null result');
        }
        dispatch(updateStatus('GETRAW-' + id, Status.SUCCESS));
        cb && cb(result);
      })
      .catch((error) => {
        console.log('Device GET Failed', error);
        dispatch(updateStatus('GET-' + id, Status.FAILURE));
        cb && cb(error);
      });
  };
}

export function getSingleDevice(id, cb = null) {
  return (dispatch, getState) => {
    dispatch(updateStatus('GET-' + id, Status.PENDING));
    getDevice(id)
      .then((result) => {
        if (result == null) {
          //something went wrong, how do we handle?
          throw Error('unexpected null result');
        }
        // console.log("GET Device:", result);
        //let devices = getState().data.devices.devicesArray;
        //let bundles = getState().data.bundles;
        //let new_devices = [...devices];
        //let index = getDeviceIndexByID(id, new_devices);
        let updatedDevice = createDevice(result);

        // if (index === -1) {
        //   // console.log("Device", id, "not in list, something is probably wrong");
        // } else {
        //   new_devices[index] = result;
        //   dispatch(updateDevicesDictionaries(new_devices, bundles));
        // }

        dispatch(updateSingleDevicePageSelectedDevice(updatedDevice));
        dispatch(updateStatus('GET-' + id, Status.SUCCESS));

        if (result.tags && result.tags.iotHubDM && result.tags.iotHubDM.softwareDownload) {
          console.log('GET Device Download URL:', result.tags.iotHubDM.softwareDownload.statusQueryGetUri);
          let url = getState().data.softwareUpdateStatusUrls[result.id];
          if (url == null) {
            /* If you fetch the device, and there is an sw download update status url and currently there isn't one in the store,
                 then save that url as the sw download status url. If there's already a url in the store, don't overwrite it: the url
                 might have been obtained directly from the software update api call and be newer than the url in the device tags.*/
            dispatch(setSoftwareUpdateStatusUrl(result.id, result.tags.iotHubDM.softwareDownload.statusQueryGetUri));
          }
        }
        cb && cb(result);
      })
      .catch((error) => {
        console.log('Device GET Failed', error);
        dispatch(updateStatus('GET-' + id, Status.FAILURE));
        cb && cb(error);
      });
  };
}

/* Given a dicitonary of device id keys and status values, update each software update status */
export function setSoftwareUpdateStatuses(statuses, version) {
  return (dispatch) => {
    if (statuses == null) {
      return;
    }
    Object.keys(statuses).forEach((id) => {
      dispatch(setSoftwareUpdateStatus(id, statuses[id].upgrade_status, version, statuses[id]?.runtime_status));
    });
  };
}

export function setSoftwareUpdateStatus(deviceID, status, version, runtimeStatus) {
  return {
    type: ActionTypes.SET_SOFTWARE_UPDATE_STATUS,
    id: deviceID,
    status: status,
    runtimeStatus: runtimeStatus,
    version: version
  };
}

export function updateActionList(action, isActive) {
  return {
    type: ActionTypes.UPDATE_ACTIONS_LIST,
    action: action,
    isActive: isActive
  };
}

export function clearActionList() {
  return {
    type: ActionTypes.CLEAR_ACTIONS_LIST
  };
}

export function removeActionFromActionList(actionId, actionStatus = 'active') {
  return {
    type: ActionTypes.REMOVE_ACTION_FROM_LIST,
    actionStatus,
    actionId
  };
}

export function doGetBundleCommissionInstances(status, fromDate, toDate, bundleId, cb_success, cb_fail) {
  return () => {
    getCommissioningActions(status, fromDate, toDate, bundleId)
      .then((res) => {
        res.instances = res.instances.filter(
          (instance) => instance?.commissioningId && !instance.commissioningId.startsWith('@cancelentity@')
        );
        if (cb_success) cb_success(res);
      })
      .catch((error) => {
        if (cb_fail) cb_fail(error);
      });
  };
}

export function doUpdateCommissioningOp() {
  return (dispatch, getState) => {
    dispatch(updateStatus('GetCommissioningActions', Status.PENDING));
    getCommissioningActions()
      .then((result) => {
        const actionsList = getState().data?.actionsList;
        const oldActiveList = actionsList && actionsList.active;
        const oldPastList = actionsList && actionsList.past;
        const instances = result.instances.filter(
          (instance) => instance?.commissioningId && !instance.commissioningId.startsWith('@cancelentity@')
        );
        const activeList = JSON.parse(JSON.stringify(oldActiveList));
        const pastList = JSON.parse(JSON.stringify(oldPastList));

        for (let i = 0; i < instances.length; i++) {
          if (instances[i].runtimeStatus === 'Pending' || instances[i].runtimeStatus === 'Running') {
            activeList[instances[i].commissioningId] = instances[i];
          } else {
            pastList[instances[i].commissioningId] = instances[i];
          }
        }

        dispatch({
          type: ActionTypes.UPDATE_ACTIONS_LIST_FOR_COMMISSION,
          activeList: activeList,
          pastList: pastList
        });
        dispatch(updateStatus('GetCommissioningActions', Status.SUCCESS));
      })
      .catch((error) => {
        console.error(error);
        dispatch(updateStatus('GetCommissioningActions', Status.FAILURE));
      });
  };
}

/* Gets result from software update status url and puts it in the redux store.
   Stored both as individual software update statu */
export function updateSoftwareUpdateStatuses(url, cb_success, cb_failed = null) {
  return (dispatch) => {
    dispatch(updateStatus('SoftwareUpdateStatus-' + url, Status.PENDING));
    softwareUpdateStatus(url)
      .then((result) => {
        if (result == null || result.devices == null) {
          dispatch(updateStatus('SoftwareUpdateStatus-' + url, Status.FAILURE));
        } else {
          let runtimeStatus = result.runtime_status.toLowerCase();
          dispatch(setSoftwareUpdateStatuses(result.devices, result.input.swVersion));
          dispatch(
            updateActionList(
              result,
              runtimeStatus !== 'completed' &&
                runtimeStatus !== 'failed' &&
                runtimeStatus !== 'warning' &&
                runtimeStatus !== 'terminated'
            )
          );
          dispatch(updateStatus('SoftwareUpdateStatus-' + url, Status.SUCCESS));
        }
        cb_success && cb_success(result);
      })
      .catch((e) => {
        console.error(e);
        dispatch(updateStatus('SoftwareUpdateStatus-' + url, Status.FAILURE));
      });
  };
}

export function setSoftwareUpdateStatusUrl(deviceID, url) {
  // console.log("adding software update status url for device", deviceID, "URL:", url);
  return {
    type: ActionTypes.SET_SOFTWARE_UPDATE_STATUS_URL,
    id: deviceID,
    url: url
  };
}

/* Requests a software update at scheduled time (or now) */
export function updateSoftware(deviceID, softwareID, scheduleTime) {
  return (dispatch) => {
    console.log('Software Update, deviceID:', deviceID);
    dispatch(setSoftwareUpdateStatus(deviceID, null, null)); //clear current update status
    dispatch(setSoftwareUpdateStatusUrl(deviceID, null));
    dispatch(updateStatus('SoftwareUpdate-' + deviceID, Status.PENDING));
    softwareUpdate(deviceID, softwareID, scheduleTime)
      .then((result) => {
        console.log('Software Update response:', result);
        dispatch(getSingleDevice(deviceID));
        dispatch(setSoftwareUpdateStatusUrl(deviceID, result.statusQueryGetUri));
        dispatch(updateStatus('SoftwareUpdate-' + deviceID, Status.SUCCESS));
      })
      .catch((error) => {
        console.log(error.message);
        dispatch(updateStatus('SoftwareUpdate-' + deviceID, Status.FAILURE));
        dispatch(setSoftwareUpdateStatus(deviceID, { status: 'error', message: error.message }, null));
      });
  };
}

export function doFetchAlarms(
  deviceIDs,
  alarmNames,
  severityList,
  alarmStates,
  from,
  to,
  size,
  next,
  sort,
  cb_success,
  cb_failed,
  concatResult
) {
  return (dispatch) => {
    let statusName = deviceIDs && deviceIDs.length === 1 ? 'fetchAlarm-' + deviceIDs[0] : 'fetchAlarms';

    dispatch(updateStatus(statusName, Status.PENDING));

    fetchAlarms(deviceIDs, alarmNames, severityList, alarmStates, from, to, size, next, sort, cb_success, cb_failed)
      .then((result) => {
        if (result.more !== false) {
          concatResult = concatResult.concat(result.items);
          dispatch(
            doFetchAlarms(
              deviceIDs,
              alarmNames,
              severityList,
              alarmStates,
              from,
              to,
              size,
              result.next,
              sort,
              cb_success,
              cb_failed,
              concatResult
            )
          );
        } else {
          dispatch(updateStatus(statusName, Status.SUCCESS));

          concatResult = concatResult.concat(result.items);
          cb_success(concatResult);
        }
      })
      .catch((error) => {
        dispatch(updateStatus(statusName, Status.FAILURE));
        cb_failed(error);
      });
  };
}

export function updateSinglePageSelectedEventLogIndex(deviceId, index) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_SELECTED_EVENTLOG_INDEX,
    deviceId: deviceId,
    selectedEventLogIndex: index
  };
}

export function updateSinglePageDisplayLiveLogs(displayLiveLogs) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_DISPLAY_LIVE_LOGS,
    displayLiveLogs
  };
}

export function updateSinglePageLocalLogList(localLogList = [], searchString = '') {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_LOCAL_LOG_LIST,
    localLogList
  };
}

export function fetchAndStoreHistoricalEventLogs(
  deviceId,
  from = 0,
  size = 10,
  sortBy = 'timestamp',
  order = 'desc',
  cb_success,
  cb_failed,
  statusName,
  timeoutStatusName,
  displayLiveLogs,
  dispatch
) {
  fetchHistoricalEventLogs(deviceId, from, size, sortBy, order, cb_success, cb_failed)
    .then((result) => {
      dispatch(storeHistoricalEventLogs(deviceId, result));
      // let events = result[0].events;
      // if (!displayLiveLogs) dispatch(updateSinglePageLocalLogList(events));
      cb_success(result);
      dispatch(updateStatus(statusName, Status.SUCCESS));
      if (timeoutStatusName) {
        dispatch(updateStatus(timeoutStatusName, Status.SUCCESS));
      }
    })
    .catch((error) => {
      console.log(error.message);
      dispatch(updateStatus(statusName, Status.FAILURE));
      if (timeoutStatusName) {
        dispatch(updateStatus(timeoutStatusName, Status.FAILURE));
      }
      cb_failed(error);
    });
}

export function doFetchHistoricalEventLogs(
  deviceId,
  from = 0,
  size = 10,
  sortBy = 'timestamp',
  order = 'desc',
  cb_success,
  cb_failed
) {
  return (dispatch, getState) => {
    let statusName = 'fetchHistoricalEventLogs-' + deviceId;

    const historicalEventLogsStatus = getState().statuses[statusName];
    const displayLiveLogs = getState().ui.singleDevicePage.displayLiveLogs;

    if (historicalEventLogsStatus !== Status.PENDING) {
      dispatch(updateStatus(statusName, Status.PENDING));
      fetchAndStoreHistoricalEventLogs(
        deviceId,
        from,
        size,
        sortBy,
        order,
        cb_success,
        cb_failed,
        statusName,
        null,
        displayLiveLogs,
        dispatch
      );
    }
  };
}

export function doUpdateHistoricalEventLogs(
  latestTimestamp,
  deviceId,
  from = 0,
  size = 10,
  sortBy = 'timestamp',
  order = 'desc',
  cb_success,
  cb_failed,
  cb_success_retrieval,
  cb_failed_retrieval
) {
  return async (dispatch, getState) => {
    let statusName = 'fetchHistoricalEventLogs-' + deviceId;
    let createSnapshotTimeoutStatusName = 'createSnapshotTimeout-' + deviceId;
    const historicalEventLogsStatus = getState().statuses[statusName];
    const displayLiveLogs = getState().ui.singleDevicePage.displayLiveLogs;

    if (historicalEventLogsStatus !== Status.PENDING) {
      dispatch(updateStatus(statusName, Status.PENDING));
      dispatch(updateStatus(createSnapshotTimeoutStatusName, Status.PENDING));

      const timeoutRunner10 = setTimeout(() => {
        console.log('time out 10 sec');
        dispatch(updateStatus(createSnapshotTimeoutStatusName, '10sec'));
      }, 10000);
      const timeoutRunner30 = setTimeout(() => {
        console.log('time out 30 sec');
        dispatch(updateStatus(createSnapshotTimeoutStatusName, '30sec'));
      }, 30000);

      //first layer to get another endpoint
      let historicalLogUri = await retrieveEventLog(deviceId)
        .then((res) => {
          if (cb_success_retrieval) cb_success_retrieval(res);
          return res.statusQueryGetUri;
        })
        .catch((error) => {
          if (cb_failed_retrieval) cb_failed_retrieval(error);
          dispatch(updateStatus(statusName, Status.FAILURE));
          console.log(error.message);
        });

      //second layer to use another endpoint to get the status in setInterval/Looping
      //until status shows "Completed", third layer will begin
      let statusRunner =
        historicalLogUri &&
        setInterval(() => {
          fetchRuntimeStatus(historicalLogUri)
            .then(async (res) => {
              if (res && res.runtimeStatus === 'Completed') {
                clearInterval(statusRunner);
                let requestCount = 0;
                // if device finished creating snapshot
                let snapshotCompleted = false;
                const createSnapshotRunner = setInterval(() => {
                  // device finished creating snapshot
                  if (snapshotCompleted) {
                    clearInterval(createSnapshotRunner);
                    clearTimeout(timeoutRunner10);
                    clearTimeout(timeoutRunner30);

                    return;
                  }

                  // timeout
                  if (requestCount === 6) {
                    clearInterval(createSnapshotRunner);
                    clearTimeout(timeoutRunner10);
                    clearTimeout(timeoutRunner30);

                    dispatch(updateStatus(createSnapshotTimeoutStatusName, Status.FAILURE));
                    dispatch(updateStatus(statusName, Status.FAILURE));
                    return;
                  }

                  requestCount += 1;
                  fetchHistoricalEventLogs(deviceId, 0, 1).then((res) => {
                    if (res[0]?.timestamp !== latestTimestamp) {
                      snapshotCompleted = true;
                      clearInterval(createSnapshotRunner);
                      clearTimeout(timeoutRunner10);
                      clearTimeout(timeoutRunner30);
                      fetchAndStoreHistoricalEventLogs(
                        deviceId,
                        from,
                        size,
                        sortBy,
                        order,
                        cb_success,
                        cb_failed,
                        statusName,
                        createSnapshotTimeoutStatusName,
                        displayLiveLogs,
                        dispatch
                      );
                    }
                  });
                }, 5000);
              } else {
                console.log('res.runtimeStatus in ELSE', res && res.runtimeStatus);
              }
            })
            .catch((error) => {
              clearInterval(statusRunner);
              dispatch(updateStatus(statusName, Status.FAILURE));
              console.log(error.message);
            });
        }, 1000);
    }
  };
}

export function storeHistoricalEventLogs(deviceId, result = []) {
  return (dispatch, getState) => {
    const {
      data: { historicalEventLogs }
    } = getState();

    dispatch({
      type: ActionTypes.STORE_HISTORICAL_EVENTLOGS,
      historicalEventLogs: { ...historicalEventLogs, [deviceId]: result }
    });
  };
}

// For future implementation for live logs
export function doFetchLiveEventLogs(
  deviceId,
  from = 0,
  size = 20,
  sortBy = 'timestamp',
  order = 'desc',
  cb_success,
  cb_failed
) {
  return async (dispatch, getState) => {
    let statusName = 'fetchLiveEventLogs-' + deviceId;
    const liveEventLogsStatus = getState().statuses[statusName];
    const displayLiveLogs = getState().ui.singleDevicePage.displayLiveLogs;

    if (liveEventLogsStatus !== Status.PENDING) {
      dispatch(updateStatus(statusName, Status.PENDING));

      //first layer to get another endpoint
      let liveLogUri = await pathcDeviceById(deviceId)
        .then((res) => res.statusQueryGetUri)
        .catch((error) => {
          dispatch(updateStatus(statusName, Status.FAILURE));
          console.log(error.message);
        });

      //second layer to use another endpoint to get the status in setInterval/Looping
      //until status shows "Completed", third layer will begin
      let statusRunnerForLiveLogs =
        liveLogUri &&
        setInterval(() => {
          fetchRuntimeStatus(liveLogUri)
            .then(async (res) => {
              if (res.runtimeStatus === 'Completed') {
                console.log('res.runtimeStatus in liveLogs IF', res.runtimeStatus);
                clearInterval(statusRunnerForLiveLogs);
                setTimeout(
                  () =>
                    fetchLiveEventLogs(deviceId, from, size, sortBy, order, cb_success, cb_failed)
                      .then((result) => {
                        if (result.length > 0) {
                          dispatch(storeLiveEventLogs(deviceId, result));
                          if (displayLiveLogs) dispatch(updateSinglePageLocalLogList(result, null, true));
                          cb_success(result);

                          dispatch(updateStatus(statusName, Status.SUCCESS));
                        } else {
                          console.log(`${deviceId} already exists in liveEventLogs`);
                        }
                      })
                      .catch((error) => {
                        console.log(error.message);
                        clearInterval(statusRunnerForLiveLogs);
                        dispatch(updateStatus(statusName, Status.FAILURE));
                        cb_failed(error);
                      }),
                  5000
                );
              } else {
                console.log('res.runtimeStatus in liveLogs ELSE', res.runtimeStatus);
              }
            })
            .catch((error) => {
              clearInterval(statusRunnerForLiveLogs);
              console.log(error.message);
              dispatch(updateStatus(statusName, Status.FAILURE));
            });
        }, 1000);
    }
  };
}

export function storeLiveEventLogs(deviceId, result = []) {
  return (dispatch, getState) => {
    const {
      data: { liveEventLogs }
    } = getState();

    dispatch({
      type: ActionTypes.STORE_HISTORICAL_EVENTLOGS,
      liveEventLogs: { ...liveEventLogs, [deviceId]: result }
    });
  };
}

export function storeAllDeviceAlarms(alarms) {
  //store alarms per device

  let deviceAlarms = {};

  alarms.forEach((x) => {
    if (deviceAlarms[x.device] == null) deviceAlarms[x.device] = [x];
    else deviceAlarms[x.device].push(x);
  });

  return {
    type: ActionTypes.STORE_ALL_DEVICE_ALARMS,
    deviceAlarms: deviceAlarms
  };
}

export function updateRasterProgress(deviceID, progress, url) {
  return {
    type: ActionTypes.UPDATE_RASTER_PROGRESS,
    id: deviceID,
    progress: progress,
    statusQueryURL: url
  };
}

export function clearRasterProgress(deviceId) {
  return {
    type: ActionTypes.CLEAR_RASTER_PROGRESS,
    id: deviceId
  };
}

function doCheckRaster({ url, deviceId, data }) {
  return (dispatch) => {
    if (!data) {
      dispatch(updateRasterProgress(deviceId, 0, url));

      checkRaster({ url }).then((result) => {
        dispatch(doCheckRaster({ url, deviceId, data: result }));
      });

      return;
    }

    console.log(data.runtimeStatus);
    if (data.runtimeStatus === 'Completed') {
      //TODO perform an action
      //console.log("DONE! Data:", data);
      dispatch(updateRasterProgress(deviceId, 100, url));
      return;
    }

    if (data.runtimeStatus === 'Failed') {
      //TODO perform an action
      //console.log("DONE! Data:", data);
      dispatch(updateRasterProgress(deviceId, 0, url));
      return;
    }

    if (
      data.runtimeStatus === 'Running' &&
      data.customStatus &&
      data.customStatus.status === 'in progress' &&
      data.customStatus.status_info &&
      data.customStatus.status_info.progress != null
    ) {
      //console.log("Updating Raster Progress:", data.customStatus.status_info.progress)
      dispatch(updateRasterProgress(deviceId, data.customStatus.status_info.progress, url));
    }

    setTimeout(() => {
      checkRaster({ url }).then((result) => {
        dispatch(doCheckRaster({ url, deviceId, data: result }));
      });
    }, 1000);
  };
}

export function doRaster(deviceId, cb_success, cb_failed) {
  return (dispatch) => {
    console.log('Raster, deviceID:', deviceId);
    dispatch(updateStatus('Raster-' + deviceId, Status.PENDING));

    startRaster(deviceId)
      .then((data) => {
        console.log('Raster response:', data);
        dispatch(doCheckRaster({ url: data.statusQueryGetUri, deviceId, data: null }));
      })
      .then((result) => {
        console.log('Raster response:', result);
        dispatch(updateStatus('Raster-' + deviceId, Status.SUCCESS));
        cb_success(result);
      })
      .catch((error) => {
        console.log(error.message);
        dispatch(updateStatus('Raster-' + deviceId, Status.FAILURE));
        cb_failed(error);
      });
  };
}

export function bulkUpdateSoftware(
  deviceIDs,
  softwareID,
  transferTime,
  activationTime,
  cb_success = null,
  cb_fail = null
) {
  return (dispatch) => {
    console.log('Bulk Software Update, deviceIds:', deviceIDs);

    for (const id of deviceIDs) {
      dispatch(setSoftwareUpdateStatus(id, null)); //clear current update status
    }

    bulkSoftwareUpdate(deviceIDs, softwareID, transferTime, activationTime)
      .then((result) => {
        console.log('Bulk Software Update response:', result);

        for (const deviceID in deviceIDs)
          dispatch(setSoftwareUpdateStatusUrl(deviceID, result.statusQueryGetUri + '?device_filter=' + deviceID));

        dispatch(updateSoftwareUpdateStatuses(result.statusQueryGetUri, cb_success));
      })
      .catch((error) => {
        console.error(error);
        console.log('Bulk Software Update error result:', error);
        cb_fail(error);
      });
  };
}

export function handleSearch(inString) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({
      type: ActionTypes.HANDLE_MAPLISTVIEW_SEARCH_QUERY,
      mapListViewSearchQuery: inString,
      filteredDevices: state.data.filteredDevices.devices
    });
  };
}

export function setLocalNameFilter(string) {
  return (dispatch, getState) => {
    const {
      ui: {
        devicesPage: { deviceGroups, selectedDeviceGroupName }
      }
    } = getState();

    return {
      type: ActionTypes.SET_LOCAL_NAME_FILTER,
      string,
      selectedDeviceGroupName,
      selectedDevicesList: deviceGroups[selectedDeviceGroupName]?.devices
    };
  };
}

export function setFilterDictionary(targetTab, filterDictionary) {
  switch (targetTab) {
    case DEVICES_PAGE_TAB.pivot:
      return {
        type: ActionTypes.SET_FILTER_LIST_PIVOT_TAB,
        filterDictionary: filterDictionary
      };
    case DEVICES_PAGE_TAB.echo:
      return {
        type: ActionTypes.SET_FILTER_LIST_ECHO_TAB,
        filterDictionary: filterDictionary
      };
    case DEVICES_PAGE_TAB.all:
      return {
        type: ActionTypes.SET_FILTER_LIST_ALL_TAB,
        filterDictionary: filterDictionary
      };
    default:
      return {};
  }
}

//Send filters through to all the device sets
export function propagateFilters(targetTab, filters) {
  return (dispatch, getState) => {
    let filteredComponentList = ['deviceTable', 'deviceMap', 'parametersTable', 'parametersGraph'];
    let deviceSetsName;
    if (targetTab === DEVICES_PAGE_TAB.pivot) {
      deviceSetsName = 'pivotDeviceSets';
    } else if (targetTab === DEVICES_PAGE_TAB.echo) {
      deviceSetsName = 'echoDeviceSets';
    } else {
      deviceSetsName = 'allDeviceSets';
    }

    filteredComponentList.forEach((c) => {
      let modFilters = { ...filters };
      if (c === 'parametersGraph') delete modFilters['text'];

      let selectedDeviceGroupName = getState().ui.devicesPage.selectedDeviceGroupName;
      let selectedDeviceGroup = getState().ui.devicesPage.deviceGroups?.[selectedDeviceGroupName];
      if (selectedDeviceGroupName && selectedDeviceGroup) {
        modFilters.deviceId = selectedDeviceGroup.devices;
      }
      // when filters changed, the map only loads for devices data within current visible region
      const activePolygonId = getState().ui.devicesPage.activePolygonId;
      const polygonList = getState().ui.devicesPage.polygons;
      const activePolygon = polygonList.find((polygon) => polygon.deviceGroupId === activePolygonId);

      if (c === 'deviceMap') {
        if (activePolygon) {
          const {
            geometry: { coordinates }
          } = activePolygon;
          modFilters.polygon = coordinates;
        } else {
          modFilters.polygon = getState().data[deviceSetsName]?.deviceMap?.polygon;
        }
      } else if (c === 'deviceTable' || c === 'parametersTable' || c === 'parametersGraph') {
        if (activePolygon) {
          const {
            geometry: { coordinates }
          } = activePolygon;
          modFilters.polygon = coordinates;
        } else {
          delete modFilters.polygon;
        }
      } else {
        delete modFilters.polygon;
      }

      if (c === 'parametersGraph') {
        if (targetTab === DEVICES_PAGE_TAB.pivot) {
          modFilters.hasBundleId = true;
        } else {
          delete modFilters['hasBundleId'];
        }
        //renaming filter properties for this specific aggregate API filter request body
        //TODO: remove this adjustment by updating redux filter without all prefix
        Object.keys(modFilters).forEach((filterName) => {
          if (filterName === 'properties.reported.productType') {
            if (
              modFilters['properties.reported.productType'] &&
              modFilters['properties.reported.productType'].length > 0
            ) {
              modFilters.productType = modFilters['properties.reported.productType'];
            }

            delete modFilters['properties.reported.productType'];
          } else if (filterName === 'properties.reported.operationState') {
            modFilters.operationState = modFilters['properties.reported.operationState'];
            delete modFilters['properties.reported.operationState'];
          } else if (filterName === 'properties.reported.adminState') {
            modFilters.adminState = modFilters['properties.reported.adminState'];
            delete modFilters['properties.reported.adminState'];
          } else if (filterName === 'provisionTime') {
            modFilters.daterange = { field: 'tags.provisionTime', ...modFilters.provisionTime };
            delete modFilters.provisionTime;
          } else if (filterName.startsWith('tags.fm-alarms')) {
            (modFilters.alarmState = modFilters.alarmState || []).push(filterName.split('.')[2]);
            delete modFilters[filterName];
          }
        });

        dispatch(
          doPostDevicesAggregate(targetTab, {
            ...defaultParameterGraphAggregateBody,
            filters: modFilters
          })
        );
      } else {
        dispatch(searchComponentFilteredDevicesV2(targetTab, c, defaultSearchBodies[c], modFilters));
      }
    });
  };
}

export function searchDevicesV2(body, versionOverride, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateStatus('searchDevicesV2', Status.PENDING));
    searchDevices(body, !versionOverride, versionOverride ? versionOverride : 'v2')
      .then((result) => {
        const formattedResult = mapDeviceSearchResult(result);

        dispatch(updateDevicesDictionary(formattedResult.devices, true));
        dispatch(updateBundlesDictionary(formattedResult.bundles));

        if (!versionOverride) {
          return {
            ...result,
            ...formattedResult
          };
        }

        return result;
      })
      .then((result) => {
        dispatch(updateStatus('searchDevicesV2', Status.SUCCESS));
        if (cb_success) {
          cb_success(result);
        }
      })
      .catch((error) => {
        dispatch(updateStatus('searchDevicesV2', Status.FAILURE));
        if (cb_fail) {
          cb_fail(error && error.message ? error.message : 'unknown');
        }
      });
  };
}

//Search filtered deviecs v2 will split device searchs per the 3 top level components,
//for their inital sets *
//filters and subFilter "text" has to be in body for the query to work (why?)
//TODO remove versionOverride
export function searchComponentFilteredDevicesV2(
  targetTab,
  componentName,
  initialBody = {},
  filters = { text: null },
  sort = null,
  shouldConcat
) {
  return (dispatch, getState) => {
    const statusName = 'searchComponentFilteredDevicesV2_' + componentName + '_' + targetTab;

    let tempFilters = { ...filters };
    Object.entries(tempFilters).forEach(([key, value]) => {
      const [type, group, name] = key.split('.');

      if (type === 'tags' && group === 'fm-alarms' && value === true) {
        delete tempFilters[key];
        if (!tempFilters.alarmState) {
          tempFilters.alarmState = [name];
        } else {
          if (!tempFilters.alarmState.includes(name)) {
            tempFilters.alarmState.push(name);
          }
        }
      }

      if (type === 'properties' && group === 'reported') {
        delete tempFilters[key];
        tempFilters[name] = value;
      }
    });

    if (targetTab === DEVICES_PAGE_TAB.pivot) {
      tempFilters.hasBundleId = true;
      if (['deviceTable', 'deviceMap'].includes(componentName)) {
        tempFilters.productType = [...PRODUCT_TYPES.donor, ...PRODUCT_TYPES.ga2];
      }
    }

    const activePolygonId = getState().ui.devicesPage.activePolygonId;
    const polygonList = getState().ui.devicesPage.polygons;
    const activePolygon = polygonList.find((polygon) => polygon.deviceGroupId === activePolygonId);
    const isShowScrollReactTable = getState().style.isShowScrollReactTable;

    if (activePolygon) {
      const {
        geometry: { coordinates }
      } = activePolygon;
      tempFilters.polygon = coordinates;
    } else if (componentName !== 'deviceMap') {
      tempFilters.polygon = undefined;
    }

    let body = {
      ...initialBody,
      filters: tempFilters,
      ...(sort != null && { sort: sort })
    };

    // sort by podName for pivot by default
    if (!body.sort && targetTab === DEVICES_PAGE_TAB.pivot && componentName === 'deviceTable') {
      body.sort = 'podName';
    }

    dispatch(updateStatus(statusName, Status.PENDING));

    searchDevices(body, true, 'v2')
      .then((result) => {
        const formattedResult = mapDeviceSearchResult(result);

        dispatch(updateDevicesDictionary(formattedResult.devices, true));
        dispatch(updateBundlesDictionary(formattedResult.bundles));

        return {
          ...result,
          ...formattedResult
        };
      })
      .then((result) => {
        let { devices, bundles, filterRequestIndex, hasMoreResults, continuationToken } = result;
        //dispatch(updateFilteredDevices(devices, bundles, filterRequestIndex));
        if (componentName === 'deviceMap') {
          dispatch(
            updateDeviceSets(
              targetTab,
              componentName,
              devices,
              bundles,
              continuationToken,
              hasMoreResults,
              filterRequestIndex,
              shouldConcat,
              tempFilters.polygon
            )
          );

          if (hasMoreResults === true) {
            dispatch(
              searchComponentFilteredDevicesV2(
                targetTab,
                componentName,
                { ...initialBody, next: continuationToken },
                tempFilters,
                null,
                true
              )
            );
          } else {
            dispatch(updateStatus(statusName, Status.SUCCESS));
            if (!isShowScrollReactTable) {
              dispatch(setScrollReactTableVisisbility(true));
            }
          }

          return;
        }

        dispatch(
          updateDeviceSets(
            targetTab,
            componentName,
            devices,
            bundles,
            continuationToken,
            hasMoreResults,
            filterRequestIndex,
            shouldConcat,
            filters.polygon
          )
        );

        dispatch(updateStatus(statusName, Status.SUCCESS));
        if (!isShowScrollReactTable) {
          dispatch(setScrollReactTableVisisbility(true));
        }
      })
      .catch((error) => {
        console.log('data error, ', error);
        dispatch(updateStatus(statusName, Status.FAILURE));
        if (!isShowScrollReactTable) {
          dispatch(setScrollReactTableVisisbility(true));
        }
      });
  };
}

export function handleSort(targetTab, componentId, sort) {
  // console.log('sort clicked ', targetTab, componentId, sort);
  return (dispatch, getState) => {
    let filterDictionary;
    let currentSort;

    switch (targetTab) {
      case DEVICES_PAGE_TAB.pivot:
        filterDictionary = getState().data?.pivotFilterDictionary;
        currentSort = getState().data?.pivotDeviceSets[componentId]?.sort;
        break;
      case DEVICES_PAGE_TAB.echo:
        filterDictionary = getState().data?.echoFilterDictionary;
        currentSort = getState().data?.echoDeviceSets[componentId]?.sort;
        break;
      case DEVICES_PAGE_TAB.all:
        filterDictionary = getState().data?.allDevicesFilterDictionary;
        currentSort = getState().data?.allDeviceSets[componentId]?.sort;
        break;
      default:
        break;
    }

    let targetSort = sort;

    if (currentSort === sort) {
      targetSort = '-' + sort;
    }

    let actionType = null;
    let defaultDeviceTableSearchBodyCopy = { ...defaultDeviceTableSearchBody };

    switch (targetTab) {
      case DEVICES_PAGE_TAB.pivot:
        if (componentId === 'deviceTable') {
          actionType = ActionTypes.UPDATE_DEVICE_SETS_DEVICETABLE_SORT_PIVOT_TAB;
        } else if (componentId === 'parametersTable') {
          actionType = ActionTypes.UPDATE_DEVICE_SETS_PARAMETERSTABLE_SORT_PIVOT_TAB;
        }
        break;
      case DEVICES_PAGE_TAB.echo:
        if (componentId === 'deviceTable') {
          actionType = ActionTypes.UPDATE_DEVICE_SETS_DEVICETABLE_SORT_ECHO_TAB;
        } else if (componentId === 'parametersTable') {
          actionType = ActionTypes.UPDATE_DEVICE_SETS_PARAMETERSTABLE_SORT_ECHO_TAB;
        }
        break;
      case DEVICES_PAGE_TAB.all:
        if (componentId === 'deviceTable') {
          actionType = ActionTypes.UPDATE_DEVICE_SETS_DEVICETABLE_SORT_ALL_TAB;
        } else if (componentId === 'parametersTable') {
          actionType = ActionTypes.UPDATE_DEVICE_SETS_PARAMETERSTABLE_SORT_ALL_TAB;
        }
        break;
      default:
        break;
    }

    if (componentId === 'parametersTable') {
      defaultDeviceTableSearchBodyCopy.coalesceBundles = false;
    }
    if (actionType != null) {
      // console.log('action sort type ', actionType);
      dispatch(addSort(actionType, targetSort));
      dispatch(
        searchComponentFilteredDevicesV2(
          targetTab,
          componentId,
          defaultDeviceTableSearchBodyCopy,
          filterDictionary,
          targetSort
        )
      );
    }
  };
}

export function addSort(actionType, sort) {
  return {
    type: actionType,
    sort: sort
  };
}

const getCurrentFilter = (targetTab, storeData) => {
  if (targetTab === DEVICES_PAGE_TAB.pivot) {
    return storeData.pivotFilterDictionary;
  }
  if (targetTab === DEVICES_PAGE_TAB.echo) {
    return storeData.echoFilterDictionary;
  }
  return storeData.allDevicesFilterDictionary;
};

export function addFilter(targetTab = DEVICES_PAGE_TAB.pivot, filter, initialLoad = false) {
  return (dispatch, getState) => {
    let list = getCurrentFilter(targetTab, getState().data);
    let newFilterDictionary = { ...list, ...filter };
    dispatch(setFilterDictionary(targetTab, newFilterDictionary));
    // query for data when filter is updated instead of initial load
    if (!initialLoad) dispatch(propagateFilters(targetTab, newFilterDictionary));
  };
}

export function addFilterToAllTabs(filter) {
  return (dispatch) => {
    dispatch(addFilter(DEVICES_PAGE_TAB.pivot, filter, false));
    dispatch(addFilter(DEVICES_PAGE_TAB.echo, filter, false));
    dispatch(addFilter(DEVICES_PAGE_TAB.all, filter, false));
  };
}

export function removeFilter(targetTab = DEVICES_PAGE_TAB.pivot, filterName) {
  return (dispatch, getState) => {
    let list = getCurrentFilter(targetTab, getState().data);
    let newFilterDictionary = { ...list };
    if (newFilterDictionary.hasOwnProperty(filterName)) {
      delete newFilterDictionary[filterName];
    }
    dispatch(setFilterDictionary(targetTab, newFilterDictionary));
    dispatch(propagateFilters(targetTab, newFilterDictionary));
  };
}

/**
 * Parses an entire filter set and updates store in one dispatch
 * @param {list} filters
 */
export function parseAllSearchFilters(
  targetTab = DEVICES_PAGE_TAB.pivot,
  filters = {},
  initialLoad = false,
  updateAllTabs = false
) {
  return (dispatch) => {
    let newFilterDictionary = { ...filters };
    let newFilterDictionaryWithoutProductType = { ...filters };
    delete newFilterDictionaryWithoutProductType['properties.reported.productType'];

    if (updateAllTabs) {
      dispatch(setFilterDictionary(DEVICES_PAGE_TAB.pivot, newFilterDictionaryWithoutProductType));
      dispatch(setFilterDictionary(DEVICES_PAGE_TAB.echo, newFilterDictionaryWithoutProductType));
      dispatch(setFilterDictionary(DEVICES_PAGE_TAB.all, newFilterDictionary));
    } else {
      dispatch(setFilterDictionary(targetTab, newFilterDictionary));
    }

    if (!initialLoad) {
      if (updateAllTabs) {
        dispatch(
          propagateFilters(DEVICES_PAGE_TAB.pivot, {
            ...newFilterDictionaryWithoutProductType,
            ...DEFAULT_TAB_FILTER.pivot
          })
        );
        dispatch(
          propagateFilters(DEVICES_PAGE_TAB.echo, {
            ...newFilterDictionaryWithoutProductType,
            ...DEFAULT_TAB_FILTER.echo
          })
        );
        dispatch(propagateFilters(DEVICES_PAGE_TAB.all, newFilterDictionary));
      } else {
        dispatch(propagateFilters(targetTab, newFilterDictionary));
      }
    }
  };
}

export function updateSoftwareVersions(deviceType) {
  return (dispatch) => {
    dispatch(updateStatus('GetSoftwareVersions', Status.PENDING));
    getSoftwareVersions(deviceType)
      .then((result) => {
        let version_list;
        dispatch(updateStatus('GetSoftwareVersions', Status.SUCCESS));
        if (result != null && result.sw_versions != null) {
          version_list = result.sw_versions;
        } else {
          version_list = [];
        }
        dispatch({
          type: ActionTypes.UPDATE_AVAILABLE_SW_VERSIONS,
          versions: version_list
        });
      })
      .catch((error) => {
        dispatch(updateStatus('GetSoftwareVersions', Status.FAILURE));
      });
  };
}

export function uploadSoftware(file, progressCallback, deviceTypes) {
  return (dispatch) => {
    dispatch(updateStatus('SoftwareUpload', Status.PENDING));
    softwareUpload(file, progressCallback, '', deviceTypes)
      .then(() => {
        dispatch(updateStatus('SoftwareUpload', Status.SUCCESS));
        dispatch(updateSoftwareVersions(''));
      })
      .catch((e) => {
        dispatch(updateStatus('SoftwareUpload', Status.FAILURE));
      });
  };
}

export function deleteSoftwareVersion(swIdentifier, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateStatus('DeleteSoftware-' + swIdentifier, Status.PENDING));
    deleteSoftware(swIdentifier)
      .then(() => {
        dispatch(updateStatus('DeleteSoftware-' + swIdentifier, Status.SUCCESS));
        dispatch(updateSoftwareVersions(''));
        if (cb_success) {
          cb_success();
        }
      })
      .catch((e) => {
        dispatch(updateStatus('DeleteSoftware-' + swIdentifier, Status.FAILURE));
        if (cb_fail) {
          cb_fail(e);
        }
      });
  };
}

export function doGetAllBeamTables() {
  return (dispatch) => {
    dispatch(updateStatus('GetAllBeamTables', Status.PENDING));
    getAllBeamTables()
      .then((result) => {
        dispatch(updateStatus('GetAllBeamTables', Status.SUCCESS));
        const allBeamTables = result?.beamtables || [];
        dispatch({
          type: ActionTypes.GET_ALL_BEAM_TABLES,
          value: allBeamTables
        });
      })
      .catch((error) => {
        dispatch(updateStatus('GetAllBeamTables', Status.FAILURE));
        console.error(error);
      });
  };
}

export function uploadBeamTable(file, progressCallback) {
  return (dispatch) => {
    dispatch(updateStatus('BeamTableUpload', Status.PENDING));
    putUploadBeamTable(file, progressCallback, '')
      .then(() => {
        dispatch(updateStatus('BeamTableUpload', Status.SUCCESS));
        dispatch(doGetAllBeamTables());
      })
      .catch((e) => {
        dispatch(updateStatus('BeamTableUpload', Status.FAILURE));
      });
  };
}

export function doDeleteBeamTable(beamtableID, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateStatus('DeleteBeamTable-' + beamtableID, Status.PENDING));
    deleteBeamTable(beamtableID)
      .then(() => {
        dispatch(updateStatus('DeleteBeamTable-' + beamtableID, Status.SUCCESS));
        dispatch(doGetAllBeamTables());
        if (cb_success) {
          cb_success();
        }
      })
      .catch((e) => {
        dispatch(updateStatus('DeleteBeamTable-' + beamtableID, Status.FAILURE));
        if (cb_fail) {
          cb_fail(e);
        }
      });
  };
}

export function getDefaultSwList() {
  return (dispatch) => {
    dispatch(updateStatus('GetDefaultSWVersion', Status.PENDING));
    getDefaultSWVersion()
      .then((result) => {
        dispatch(updateStatus('GetDefaultSWVersion', Status.SUCCESS));
        let defaultSWVersionsList = result;
        dispatch({
          type: ActionTypes.GET_DEFAULT_SW_VERSION,
          value: defaultSWVersionsList
        });
      })
      .catch((error) => {
        dispatch(updateStatus('GetDefaultSWVersion', Status.FAILURE));
        console.error(error);
      });
  };
}

export function updateDefaultsList(newSWVersion, index, defaultSwVersionId) {
  return (dispatch) => {
    const data = {
      id: defaultSwVersionId,
      defaultSWVersion: newSWVersion
    };

    dispatch(updateStatus('PatchDefaultSWVersion', Status.PENDING));
    updateDefaultSWVersion(data)
      .then((result) => {
        if (result.ok) {
          dispatch(updateStatus('PatchDefaultSWVersion', Status.SUCCESS));
          let defaultSWVersionsList = [];
          getDefaultSWVersion().then((result) => {
            defaultSWVersionsList = result;
            dispatch({
              type: ActionTypes.UPDATE_DEFAULT_SW_VERSION,
              value: defaultSWVersionsList
            });
          });
        } else {
          dispatch(updateStatus('PatchDefaultSWVersion', Status.FAILURE));
          throw new Error('Updating default SW version failed.');
        }
      })
      .catch((error) => {
        console.log('Updating default SW version failed: ', error.message);
        dispatch(updateStatus('PatchDefaultSWVersion', Status.FAILURE));
      });
  };
}

export function getActionsList(canCommission) {
  return (dispatch) => {
    dispatch(updateStatus('GetActions', Status.PENDING));
    getActions()
      .then((result) => {
        /* Split actions into active and past */
        let activeList = {};
        let pastList = {};

        let instances = result.instances;

        for (let i = 0; i < instances.length; i++) {
          if (
            instances[i].runtime_status === 'Completed' ||
            instances[i].runtime_status === 'Failed' ||
            instances[i].runtime_status === 'Terminated'
          ) {
            pastList[instances[i].instance_id] = instances[i];
          } else {
            activeList[instances[i].instance_id] = instances[i];
          }
        }
        dispatch({
          type: ActionTypes.SET_ACTIONS_LIST,
          activeList: activeList,
          pastList: pastList
        });
        dispatch(updateStatus('GetActions', Status.SUCCESS));
      })
      .catch((error) => {
        dispatch(updateStatus('GetActions', Status.FAILURE, error));
      });

    if (!canCommission) return;

    dispatch(updateStatus('GetCommissioningActions', Status.PENDING));
    getCommissioningActions()
      .then((result) => {
        /* Split actions into active and past */
        const activeList = {};
        const pastList = {};

        const instances = result.instances.filter(
          (instance) => instance?.commissioningId && !instance.commissioningId.startsWith('@cancelentity@')
        );

        for (let i = 0; i < instances.length; i++) {
          if (
            instances[i].runtimeStatus === 'Completed' ||
            instances[i].runtimeStatus === 'Failed' ||
            instances[i].runtimeStatus === 'Terminated'
          ) {
            pastList[instances[i].commissioningId] = instances[i];
          } else {
            // handle status message to display cancelling instead of cancelled from orch instance (2hop)
            let modifiedInstance = { ...instances[i] };
            if (modifiedInstance.runtimeStatus === 'Running' && modifiedInstance.customStatus?.status === 'cancelled') {
              modifiedInstance.customStatus.status = 'cancelling';
            }
            activeList[instances[i].commissioningId] = modifiedInstance;
          }
        }
        dispatch({
          type: ActionTypes.SET_ACTIONS_LIST,
          activeList: activeList,
          pastList: pastList
        });
        dispatch(updateStatus('GetCommissioningActions', Status.SUCCESS));
      })
      .catch(() => {
        dispatch(updateStatus('GetCommissioningActions', Status.FAILURE));
      });
  };
}

export function doLockUnlock(deviceID, lockState, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateStatus('LockUnlock-' + deviceID, Status.PENDING));
    setLockUnlock(deviceID, lockState)
      .then((result) => {
        if (result.customStatus.status === 'completed') {
          dispatch(updateStatus('LockUnlock-' + deviceID, Status.SUCCESS));
          if (cb_success) {
            cb_success();
          }
        } else {
          dispatch(updateStatus('LockUnlock-' + deviceID, Status.FAILURE));
          if (cb_fail) {
            cb_fail(result.customStatus.message);
          }
        }
      })
      .catch((e) => {
        dispatch(updateStatus('LockUnlock-' + deviceID, Status.FAILURE));
        if (cb_fail) {
          cb_fail(e);
        }
      });
  };
}

export function doSetWifi(deviceID, status, ssid, psk, enableTimer, disableTimer, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateStatus('SetWifi-' + deviceID, Status.PENDING));
    setWifi(deviceID, status, ssid, psk, enableTimer, disableTimer)
      .then((result) => {
        if (result.customStatus.status === 'completed') {
          dispatch(updateStatus('SetWifi-' + deviceID, Status.SUCCESS));
          if (cb_success) {
            cb_success();
          }
        } else {
          dispatch(updateStatus('SetWifi-' + deviceID, Status.FAILURE));
          if (cb_fail) {
            cb_fail(result.customStatus.message);
          }
        }
      })
      .catch((e) => {
        dispatch(updateStatus('SetWifi-' + deviceID, Status.FAILURE));
        if (cb_fail) {
          cb_fail(e);
        }
      });
  };
}

/**
 * Triggers Blink Device LED API and update its status/error message in the store
 * @param {string} deviceID target device ID
 * @param {function} cb_success success callback
 * @param {function} cb_fail failure callback
 * @param {boolean} isGa2 whether the device is GA2
 * @param {string} networkElement target device type
 * @param {string} serialId serial ID for GA2 devices
 */
export function doBlinkLED(deviceID, cb_success = null, cb_fail = null, isGa2 = false, networkElement = 'DU', serialId = '') {
  return (dispatch) => {
    dispatch(updateStatus('BlinkLED-' + deviceID, Status.PENDING));
    blinkDeviceLED(deviceID, isGa2, networkElement, serialId)
      .then((res) => {
        if (res.customStatus.status === 'completed') {
          dispatch(updateStatus('BlinkLED-' + deviceID, Status.SUCCESS));
          if (cb_success) cb_success();

          // reset status after 5s for unmounting component during pending/success cases
          setTimeout(() => {
            dispatch(updateStatus('BlinkLED-' + deviceID, Status.NONE));
          }, 5000);
        } else {
          dispatch(updateStatus('BlinkLED-' + deviceID, Status.FAILURE));
          dispatch(updateStatus('BlinkLED-' + deviceID + '-ErrorMessage', res.customStatus.message));
          if (cb_fail) cb_fail(res.customStatus.message);
        }
      })
      .catch((error) => {
        console.log('LED reducer error: ' + error);
        dispatch(updateStatus('BlinkLED-' + deviceID, Status.FAILURE));
        dispatch(updateStatus('BlinkLED-' + deviceID + '-ErrorMessage', error));
        cb_fail(error);
      });
  };
}

export function updateLEDStatus(deviceID, status) {
  return (dispatch) => {
    dispatch(updateStatus('BlinkLED-' + deviceID, status));
  };
}

export function doGetAvailablePmCounters(from, to, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateStatus('GetAvailablePmCounters', Status.PENDING));
    getAvailablePmCounters(from, to)
      .then((result) => {
        dispatch(updateStatus('GetAvailablePmCounters', Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus('GetAvailablePmCounters', Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doGetAvailableCmCounters(from, to, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateStatus('GetAvailableCmCounters', Status.PENDING));
    getAvailableCmCounters(from, to)
      .then((result) => {
        dispatch(updateStatus('GetAvailableCmCounters', Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus('GetAvailableCmCounters', Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function setDeviceDisplayMode(mode) {
  return (dispatch, getState) => {
    const activeTab = getState().ui.devicesPage.activeTab;
    let type;
    switch (activeTab) {
      case DEVICES_PAGE_TAB.pivot:
        type = ActionTypes.UI_DEVICESPAGE_SET_DEVICE_DISPLAY_MODE_PIVOT_TAB;
        break;
      case DEVICES_PAGE_TAB.echo:
        type = ActionTypes.UI_DEVICESPAGE_SET_DEVICE_DISPLAY_MODE_ECHO_TAB;
        break;
      case DEVICES_PAGE_TAB.all:
        type = ActionTypes.UI_DEVICESPAGE_SET_DEVICE_DISPLAY_MODE_ALL_TAB;
        break;
      default:
        break;
    }
    dispatch({
      type,
      displayMode: mode
    });
  };
}

export function updatePivotDictionary(dict) {
  return {
    type: ActionTypes.UPDATE_LINKED_DEVICES,
    pivotDictionary: dict
  };
}

export function doGetBundle(bundleId, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateBundleStatus(bundleId, Status.PENDING));
    getBundle(bundleId)
      .then((result) => {
        dispatch(updateBundleStatus(bundleId, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateBundleStatus(bundleId, Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doCreateBundle(bundleObj, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateBundleStatus('CreateBundle', Status.PENDING));
    createBundle(bundleObj)
      .then((result) => {
        dispatch(updateBundleStatus('CreateBundle', Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateBundleStatus('CreateBundle', Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doPatchBundle(bundleId, bundleObj, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateBundleStatus('PatchBundle-' + bundleId, Status.PENDING));
    patchBundle(bundleId, bundleObj)
      .then((result) => {
        dispatch(updateBundleStatus('PatchBundle-' + bundleId, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateBundleStatus('PatchBundle-' + bundleId, Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doDeleteBundle(bundleId, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateBundleStatus('DeleteBundle-' + bundleId, Status.PENDING));
    deleteBundle(bundleId)
      .then((result) => {
        dispatch(updateBundleStatus('DeleteBundle-' + bundleId, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateBundleStatus('DeleteBundle-' + bundleId, Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doGetSupportedCommissioningWebsiteVersions() {
  return (dispatch) => {
    dispatch(updateStatus('getSupportedCommissioningWebsiteVersions', Status.PENDING));
    getSupportedCommissioningSoftwareVersions()
      .then((result) => {
        let version_list;
        dispatch(updateStatus('getSupportedCommissioningWebsiteVersions', Status.SUCCESS));
        if (result != null && result.versions != null) {
          version_list = result.versions;
        } else {
          version_list = [];
        }
        dispatch({
          type: ActionTypes.UPDATE_SUPPORTED_COMMISSIONING_WEBSITE_VERSIONS,
          versions: version_list
        });
      })
      .catch((error) => {
        dispatch(updateStatus('getSupportedCommissioningWebsiteVersions', Status.FAILURE));
      });
  };
}

export function updateUsersManagementUsersList(local = [], original = [], searchString = '') {
  let newLocal = [];
  searchString = searchString.toLowerCase().trim();
  let copiedOriginal = JSON.parse(JSON.stringify(original));
  if (copiedOriginal && searchString !== '') {
    //filter the original list
    copiedOriginal.forEach((user) => {
      if (user.email.toLowerCase().includes(searchString) || user.name.toLowerCase().includes(searchString)) {
        newLocal.push(user);
      }
    });
  }

  return {
    type: ActionTypes.UI_USERS_MANAGEMENT_PAGE_USERS,
    local: searchString === '' ? copiedOriginal : newLocal,
    original: copiedOriginal
  };
}

export function updateUsersManagementRoleUsersList(roleUsers) {
  return {
    type: ActionTypes.UI_USERS_MANAGEMENT_PAGE_ROLE_USERS,
    roleUsers
  };
}

export function updateUsersManagementRoleList(roleList) {
  return {
    type: ActionTypes.UI_USERS_MANAGEMENT_PAGE_ROLE_LIST,
    roleList
  };
}

export function updateUsersManagementSearchString(searchString) {
  return {
    type: ActionTypes.UI_USERS_MANAGEMENT_PAGE_SEARCH_STRING,
    searchString
  };
}

export function updateUsersManagementSelectedUserId(selectedUserId) {
  return {
    type: ActionTypes.UI_USERS_MANAGEMENT_PAGE_SELECTED_USER_ID,
    selectedUserId
  };
}

export function updateUsersManagementSelectedUsersList(selectedUsersDictionary) {
  return {
    type: ActionTypes.UI_USERS_MANAGEMENT_PAGE_UPDATE_SELECTED_USERS_LIST,
    selectedUsersDictionary
  };
}

export function updateUsersManagementSelectedUsersData(selectedUsersData) {
  return {
    type: ActionTypes.UI_USERS_MANAGEMENT_PAGE_UPDATE_SELECTED_USERS_DATA,
    selectedUsersData
  };
}

export function removeUsersManagementSelectedUserData(userKey) {
  return {
    type: ActionTypes.UI_USERS_MANAGEMENT_PAGE_REMOVE_SELECTED_USER_DATA,
    userKey
  };
}

export function clearUsersManagementSelectedUsersList() {
  return {
    type: ActionTypes.UI_USERS_MANAGEMENT_PAGE_CLEAR_SELECTED_USERS_LIST
  };
}

export function clearUsersManagementSelectedUsersData() {
  return {
    type: ActionTypes.UI_USERS_MANAGEMENT_PAGE_CLEAR_SELECTED_USERS_DATA
  };
}

export function setUsersManagementSelectMode(selectMode) {
  return {
    type: ActionTypes.UI_USERS_MANAGEMENT_PAGE_SET_SELECT_MODE,
    selectMode
  };
}

export function fetchAndUpdateRoleUsers() {
  return (dispatch, getState) => {
    let getRoleUsersStatusName = 'GET-Role-Users';
    dispatch(updateStatus(getRoleUsersStatusName, Status.PENDING));
    getRoleUsers()
      .then((result) => {
        let roleUsers = {};

        result &&
          result.forEach((roleUser) => {
            if (roleUser.user_id && roleUser.roles) {
              roleUsers[roleUser.user_id] = roleUser.roles;
            }
          });

        dispatch(updateUsersManagementRoleUsersList(roleUsers));
        dispatch(updateStatus(getRoleUsersStatusName, Status.SUCCESS));
      })
      .catch((error) => {
        dispatch(updateStatus(getRoleUsersStatusName, Status.FAILURE));
        console.error(error);
      });
  };
}

export function fetchAndUpdateUsers() {
  return (dispatch, getState) => {
    let getUsersStatusName = 'GET-Users';
    dispatch(updateStatus(getUsersStatusName, Status.PENDING));

    getUsers()
      .then((result) => {
        dispatch(updateUsersManagementUsersList(result, result, ''));
        dispatch(updateStatus(getUsersStatusName, Status.SUCCESS));
      })
      .catch((error) => {
        dispatch(updateStatus(getUsersStatusName, Status.FAILURE));
        console.error(error);
      });
  };
}

export function fetchAndUpdateUsersManagementRoleList(parent) {
  if (!parent) return;
  return (dispatch, getState) => {
    let getRoleListStatusName = 'GET-Role-List';
    dispatch(updateStatus(getRoleListStatusName, Status.PENDING));

    getRoleList()
      .then((result) => {
        let selectedRoles = {};

        result &&
          result.forEach((role) => {
            selectedRoles[role.role] = { id: role._id, active: false };
          });
        dispatch(updateUsersManagementRoleList(result));
        parent && parent.setState({ selectedRoles });
        dispatch(updateStatus(getRoleListStatusName, Status.SUCCESS));
      })
      .catch((error) => {
        dispatch(updateStatus(getRoleListStatusName, Status.FAILURE));
        console.error(error);
      });
  };
}

export function getDevicesIds() {
  return (dispatch, getState) => {
    let statusName = 'GET-Devices-IDs';

    dispatch(updateStatus(statusName, Status.PENDING));
    searchDevicesIds()
      .then((devicesIds) => {
        if (devicesIds) {
          dispatch(updateDevicesIds(devicesIds));
          dispatch(updateStatus(statusName, Status.SUCCESS));
        } else {
          throw Error('error retreiving devicesIds');
        }
      })
      .catch((error) => {
        console.log('error fetching devicesIds:', error);
        dispatch(updateStatus(statusName, Status.FAILURE));
      });
  };
}

export function doGetRoleList(cb_success = null, cb_fail = null) {
  return (dispatch) => {
    let getRoleListStatusName = 'GET-Role-List';
    dispatch(updateStatus(getRoleListStatusName, Status.PENDING));
    getRoleList()
      .then((result) => {
        dispatch(updateStatus(getRoleListStatusName, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus(getRoleListStatusName, Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doGetAllPermissionsList(cb_success = null, cb_fail = null) {
  return (dispatch) => {
    let getAllPermissionListStatus = 'GET-Permission-List';
    dispatch(updateStatus(getAllPermissionListStatus, Status.PENDING));
    getAllPermissionList()
      .then((result) => {
        dispatch(updateStatus(getAllPermissionListStatus, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus(getAllPermissionListStatus, Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doRoleCreate(roleName, roleDesc, rolePermissionsDict, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateStatus('doRoleCreate', Status.PENDING));
    createRole(roleName, roleDesc, rolePermissionsDict)
      .then((result) => {
        dispatch(updateStatus('doRoleCreate', Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus('doRoleCreate', Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doRoleUpdate(roleId, roleDesc, rolePermissionsDict, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateStatus('doRoleUpdate', Status.PENDING));
    updateRole(roleId, roleDesc, rolePermissionsDict)
      .then((result) => {
        dispatch(updateStatus('doRoleUpdate', Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus('doRoleUpdate', Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doRoleDelete(roleId, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateStatus('doRoleDelete', Status.PENDING));
    deleteRole(roleId)
      .then((result) => {
        dispatch(updateStatus('doRoleDelete', Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus('doRoleDelete', Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doRefreshRolesAndPermissions(cb_success = null, cb_fail = null) {
  return (dispatch) => {
    dispatch(updateStatus('doRefreshRolesAndPermissions', Status.PENDING));
    getPermissions()
      .then((result) => {
        let permissionsList = getPermissionsFromRolePermissions(result);

        dispatch(setUserRoles(result));
        dispatch(setUserPermissions(permissionsList));

        localStorage.setItem('permissions', JSON.stringify(permissionsList));
        localStorage.setItem('roles', JSON.stringify(result));
        cb_success();
      })
      .catch((e) => {
        dispatch(updateStatus('doRefreshRolesAndPermissions', Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doUpdatePermissionsFromStorage() {
  return (dispatch, getState) => {
    try {
      let localPermissions = localStorage.getItem('permissions');
      let parsedPermissions = JSON.parse(localPermissions);

      if (localPermissions != null && localPermissions.length > 0) {
        let state = getState();
        let permissions =
          state.data.rolePermissions && state.data.rolePermissions.permissions
            ? state.data.rolePermissions.permissions
            : null;

        if (permissions == null || permissions.length === 0) {
          dispatch(setUserPermissions(parsedPermissions));
        }
      }
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(error);
      }
    }
  };
}

export function doUpdateRolesFromStorage() {
  return (dispatch, getState) => {
    try {
      const localParsedRoles = JSON.parse(localStorage.getItem('roles'));
      const reduxStoreRoles = getState().data?.rolePermissions?.roles;

      // retrieve roles if roles list is not found in localStorage
      if (!localParsedRoles && !reduxStoreRoles) {
        getPermissions()
          .then((result) => {
            let permissionsList = getPermissionsFromRolePermissions(result);
            dispatch(setUserRoles(result));
            dispatch(setUserPermissions(permissionsList));

            localStorage.setItem('permissions', JSON.stringify(permissionsList));
            localStorage.setItem('roles', JSON.stringify(result));
          })
          .catch((error) => {
            if (process.env.NODE_ENV !== 'production') {
              console.error(error);
            }
          });
      }

      if (localParsedRoles && !reduxStoreRoles) {
        dispatch(setUserRoles(localParsedRoles));
      }
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(error);
      }
    }
  };
}

export function doUpdateAllUserDeviceGroups(deviceGroups) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_UPDATE_ALL_USER_DEVICE_GROUPS,
    deviceGroups
  };
}

export function doEditSingleDeviceGroup(name, newDeviceGroup) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_EDIT_SINGLE_DEVICE_GROUP,
    name,
    newDeviceGroup
  };
}

export function doUpdateAllUserDevicePolygons(polygons) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_UPDATE_ALL_USER_DEVICE_POLYGONS,
    polygons
  };
}

export function doCreateUserDevicePolygon(polygon) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_ADD_USER_DEVICE_POLYGON,
    polygon
  };
}

export function doPolygonDelete(deviceGroupId) {
  return {
    type: ActionTypes.UI_DEVICESPAGE_DELETE_USER_DEVICE_POLYGON,
    deviceGroupId
  };
}

export function doGetAllUserDeviceGroups(cb_success = null, cb_fail = null) {
  return (dispatch) => {
    let getAllUserDeviceGroupsStatus = 'GET-User-DeviceGroups';
    dispatch(updateStatus(getAllUserDeviceGroupsStatus, Status.PENDING));
    getAllUserDeviceGroups()
      .then((result) => {
        let deviceGroups = {};
        result &&
          result.groups &&
          result.groups.forEach((group) => {
            deviceGroups[group.name] = group;
          });
        dispatch(doUpdateAllUserDeviceGroups(deviceGroups));

        dispatch(updateStatus(getAllUserDeviceGroupsStatus, Status.SUCCESS));
        if (cb_success) cb_success(deviceGroups);
      })
      .catch((e) => {
        dispatch(updateStatus(getAllUserDeviceGroupsStatus, Status.FAILURE));
        console.error('Error getting all user device groups', e);
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doGetAllUserDevicePolygons(cb_success = null, cb_fail = null) {
  return (dispatch) => {
    let getAllUserDevicePolygonsStatus = 'GET-User-DevicePolygons';
    dispatch(updateStatus(getAllUserDevicePolygonsStatus, Status.PENDING));
    getAllUserDevicePolygons()
      .then((result) => {
        dispatch(doUpdateAllUserDevicePolygons(result.polygons));
        dispatch(updateStatus(getAllUserDevicePolygonsStatus, Status.SUCCESS));
        if (cb_success) cb_success(result.polygons);
      })
      .catch((e) => {
        dispatch(updateStatus(getAllUserDevicePolygonsStatus, Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doDeviceGroupCreate(groupName = '', isDefault = false, data = [], cb_success = null, cb_fail = null) {
  return (dispatch) => {
    let createDeviceGroupStatus = `doDeviceGroupCreate-${data.deviceGroupName}`;
    dispatch(updateStatus(createDeviceGroupStatus, Status.PENDING));
    createDeviceGroup(groupName, isDefault, data)
      .then((result) => {
        if (result.message === 'success') {
          dispatch(updateStatus(createDeviceGroupStatus, Status.SUCCESS));
          dispatch(doGetAllUserDeviceGroups());
        } else {
          if (cb_fail) cb_fail(result.message);
          dispatch(updateStatus(createDeviceGroupStatus, Status.FAILURE));
        }
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus(createDeviceGroupStatus, Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doPolygonDuplicate(deviceGroupId, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    let createDevicePolygonStatus = 'POST-User-DevicePolygon-Update';
    dispatch(updateStatus(createDevicePolygonStatus, Status.PENDING));

    duplicateDeviceGroupPolygon(deviceGroupId)
      .then((result) => {
        dispatch(updateStatus(createDevicePolygonStatus, Status.SUCCESS));
        if (cb_success) cb_success(result.newDuplicatePolygonName);
      })

      .catch((e) => {
        dispatch(updateStatus(createDevicePolygonStatus, Status.FAILURE));
        console.log(e);

        e.text().then((errorMessage) => {
          const error = JSON.parse(errorMessage);
          dispatch(
            addToastNotification({
              title: 'Error',
              description: error.message
            })
          );
          if (cb_fail) cb_fail(error.message);
        });
      });
  };
}

export function doPolygonCreate(format, data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    let createDevicePolygonStatus = 'POST-User-DevicePolygon';
    dispatch(updateStatus(createDevicePolygonStatus, Status.PENDING));
    createDeviceGroupPolygon(format, data)
      .then((result) => {
        dispatch(doGetAllUserDevicePolygons());
        dispatch(updateStatus(createDevicePolygonStatus, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus(createDevicePolygonStatus, Status.FAILURE));
        e.text().then((errorMessage) => {
          const error = JSON.parse(errorMessage);
          dispatch(
            addToastNotification({
              id: data.properties.name,
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        });
      });
  };
}

export function doDeviceGroupPolygonDelete(deviceGroupId, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const deleteDevicePolygonStatus = 'DELETE-User-DevicePolygon';
    dispatch(updateStatus(deleteDevicePolygonStatus, Status.PENDING));
    deleteDeviceGroup(deviceGroupId)
      .then((result) => {
        dispatch(doPolygonDelete(result.deviceGroupId));
        dispatch(updateStatus(deleteDevicePolygonStatus, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus(deleteDevicePolygonStatus, Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doPolygonUpdate(deviceGroupId, data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    let updateDevicePolygonStatus = 'PUT-User-DevicePolygon';
    dispatch(updateStatus(updateDevicePolygonStatus, Status.PENDING));
    updateDeviceGroupPolygon(deviceGroupId, data)
      .then((result) => {
        dispatch(doGetAllUserDevicePolygons());
        dispatch(updateStatus(updateDevicePolygonStatus, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus(updateDevicePolygonStatus, Status.FAILURE));
        e.text().then((errorMessage) => {
          const error = JSON.parse(errorMessage);
          dispatch(
            addToastNotification({
              id: data.properties.name,
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        });
      });
  };
}

export function doPolygonImport(data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    let createDevicePolygonStatus = 'POST-User-DevicePolygon';
    dispatch(updateStatus(createDevicePolygonStatus, Status.PENDING));
    importDeviceGroupPolygon(data)
      .then((result) => {
        dispatch(doGetAllUserDevicePolygons());
        dispatch(updateStatus(createDevicePolygonStatus, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus(createDevicePolygonStatus, Status.FAILURE));
        e.text().then((errorMessage) => {
          const error = JSON.parse(errorMessage);
          dispatch(
            addToastNotification({
              id: 'test',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        });
      });
  };
}

export function doPolygonExport(deviceGroupId, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    let createDevicePolygonStatus = 'POST-User-DevicePolygon';
    dispatch(updateStatus(createDevicePolygonStatus, Status.PENDING));
    exportDeviceGroupPolygon(deviceGroupId)
      .then((result) => {
        dispatch(updateStatus(createDevicePolygonStatus, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus(createDevicePolygonStatus, Status.FAILURE));
        e.text().then((errorMessage) => {
          const error = JSON.parse(errorMessage);
          dispatch(
            addToastNotification({
              id: 'test',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        });
      });
  };
}

export function doPolygonsSort(data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    let getAllUserDevicePolygonsStatus = 'GET-User-DevicePolygons';
    dispatch(updateStatus(getAllUserDevicePolygonsStatus, Status.PENDING));
    sortUserDevicePolygons(data)
      .then((result) => {
        dispatch(doUpdateAllUserDevicePolygons(result.polygons));
        dispatch(updateStatus(getAllUserDevicePolygonsStatus, Status.SUCCESS));
        if (cb_success) cb_success(result.polygons);
      })
      .catch((e) => {
        dispatch(updateStatus(getAllUserDevicePolygonsStatus, Status.FAILURE));

        e.text().then((errorMessage) => {
          const error = JSON.parse(errorMessage);
          dispatch(
            addToastNotification({
              id: 'test',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        });
      });
  };
}

export function doDeviceGroupUpdate(
  deviceGroupId,
  deviceGroupName,
  isDefault,
  devices,
  userId,
  cb_success = null,
  cb_fail = null
) {
  return (dispatch) => {
    let updateDeviceGroupStatus = `doDeviceGroupUpdate-${deviceGroupId}`;
    dispatch(updateStatus(updateDeviceGroupStatus, Status.PENDING));
    updateDeviceGroup(deviceGroupId, deviceGroupName, isDefault, devices)
      .then((result) => {
        let newDeviceGroup = {
          name: deviceGroupName,
          default: isDefault,
          devices,
          userId,
          deviceGroupId
        };
        dispatch(updateStatus(updateDeviceGroupStatus, Status.SUCCESS));
        dispatch(doEditSingleDeviceGroup(deviceGroupName, newDeviceGroup));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        console.log(e);
        dispatch(updateStatus(updateDeviceGroupStatus, Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doDeviceGroupDelete(deviceGroupId, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    let deleteDeviceGroupStatus = `doDeviceGroupDelete-${deviceGroupId}`;
    dispatch(updateStatus(deleteDeviceGroupStatus, Status.PENDING));
    deleteDeviceGroup(deviceGroupId)
      .then((result) => {
        dispatch(updateStatus(deleteDeviceGroupStatus, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((e) => {
        dispatch(updateStatus(deleteDeviceGroupStatus, Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function doDeviceGroupUndoDeletion(deviceGroupId, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    let deleteDeviceGroupStatus = `doDeviceGroupUndoDeletion-${deviceGroupId}`;
    dispatch(updateStatus(deleteDeviceGroupStatus, Status.PENDING));
    undoDeviceGroupDeletion(deviceGroupId)
      .then((result) => {
        dispatch(updateStatus(deleteDeviceGroupStatus, Status.SUCCESS));
        if (cb_success) cb_success();
      })
      .catch((e) => {
        dispatch(updateStatus(deleteDeviceGroupStatus, Status.FAILURE));
        if (cb_fail) cb_fail(e);
      });
  };
}

export function updateDevicesPageManageFilterModal(isOpen) {
  return {
    type: ActionTypes.UI_USER_PREFERENCE_MANAGE_MODAL_IS_OPEN,
    isOpen
  };
}

export function updateDevicesPageCreateFilterModal(isOpen) {
  return {
    type: ActionTypes.UI_USER_PREFERENCE_CREATE_MODAL_IS_OPEN,
    isOpen
  };
}

/**
 * Updates active preference displayed on devices page.
 * @param {string} preferenceId
 */
export function updateActiveFilterPreference(preferenceId) {
  return {
    type: ActionTypes.UI_USER_PREFERENCE_ACTIVE_FILTER_SET,
    preferenceId
  };
}

export function updateDevicesPageCreateSiteModal(isOpen) {
  return {
    type: ActionTypes.UI_CREATE_SITE_MODAL_OPEN,
    isOpen
  };
}

export function getRasterHeatmapInfo(commissioningId, cb_success, cb_failed) {
  return (dispatch) => {
    dispatch(updateStatus(`getRasterHeatmapInfo-${commissioningId}`, Status.PENDING));
    getRasterInfo(commissioningId)
      .then((result) => {
        dispatch(updateStatus(`getRasterHeatmapInfo-${commissioningId}`, Status.SUCCESS));
        if (cb_success) cb_success();
        let heatmap = result.heatmap;
        let beamrank = result.beamrank;
        let activeBeam = result.activeBeam;
        let { min, max } = getSuggestedHeatmapRange('ga1');

        for (let i = 0; i < heatmap.length; i++) {
          for (let j = 0; j < heatmap[i].length; j++) {
            min = Math.min(min, heatmap[i][j]);
            max = Math.max(max, heatmap[i][j]);
          }
        }

        dispatch({
          type: ActionTypes.UPDATE_HEATMAP,
          heatmap: heatmap,
          min: Math.floor(min / 5) * 5,
          max: Math.ceil(max / 5) * 5,
          valid: true,
          beamrank: beamrank,
          activeBeam: activeBeam
        });
      })
      .catch((error) => {
        if (cb_failed) cb_failed();
        dispatch(updateStatus(`getRasterHeatmapInfo-${commissioningId}`, Status.FAILURE));
        console.log('Error in getRasterHeatmapInfo: ', error);
      });
  };
}

export function doInitiateCommissioning(bundleId, cb_success = null, cb_failed = null) {
  return async (dispatch) => {
    dispatch(updateStatus(`initiateCommissioning-${bundleId}`, Status.PENDING));
    await initiateCommissioning(bundleId)
      .then((res) => {
        dispatch(updateStatus(`initiateCommissioning-${bundleId}`, Status.SUCCESS));
        cb_success && cb_success(res);
      })
      .catch((error) => {
        dispatch(updateStatus(`initiateCommissioning-${bundleId}`, Status.FAILURE));
        cb_failed && cb_failed(error);
        console.log(error.message);
      });
  };
}

export function doTerminateCommissionOp(commissioningId, cb_success = null, cb_failed = null) {
  return (dispatch) => {
    dispatch(updateStatus(`terminateCommissionOp-${commissioningId}`, Status.PENDING));
    terminateCommissionOp(commissioningId)
      .then((res) => {
        dispatch(updateStatus(`terminateCommissionOp-${commissioningId}`, Status.SUCCESS));
        cb_success && cb_success(res);
      })
      .catch((error) => {
        dispatch(updateStatus(`terminateCommissionOp-${commissioningId}`, Status.FAILURE));
        cb_failed && cb_failed(error);
        console.log('Terminate commissioning operation error: ', error.message);
      });
  };
}

export function doSetActiveBeam(
  commissioningId,
  azEl = { azimuth: null, elevation: null },
  cb_success = null,
  cb_failed = null
) {
  return (dispatch) => {
    dispatch(updateStatus(`setActiveBeam-${commissioningId}`, Status.PENDING));
    setActiveBeam(commissioningId, azEl)
      .then((res) => {
        dispatch(updateStatus(`setActiveBeam-${commissioningId}`, Status.SUCCESS));
        cb_success && cb_success(res);
      })
      .catch((error) => {
        dispatch(updateStatus(`setActiveBeam-${commissioningId}`, Status.FAILURE));
        cb_failed && cb_failed(error);
        console.log(error.message);
      });
  };
}

export function doSetServicesActiveBeam(commissioningId, data, cb_success = null, cb_failed = null) {
  return (dispatch) => {
    dispatch(updateStatus(`setActiveBeam-${commissioningId}`, Status.PENDING));
    setServicesActiveBeam(commissioningId, data)
      .then((res) => {
        dispatch(updateStatus(`setActiveBeam-${commissioningId}`, Status.SUCCESS));
        cb_success && cb_success(res);
      })
      .catch((error) => {
        dispatch(updateStatus(`setActiveBeam-${commissioningId}`, Status.FAILURE));
        cb_failed && cb_failed(error);
        console.log(error.message);
      });
  };
}

export function updateFeatureToggle(data) {
  return {
    type: ActionTypes.UPDATE_FEATURE_TOGGLE,
    ...data
  };
}

export function doGetFeatureToggle(cb_success, cb_failed) {
  return (dispatch, getState) => {
    let getFeatureToggleStatusName = 'GET-FeatureToggle';
    dispatch(updateStatus(getFeatureToggleStatusName, Status.PENDING));

    getFeatureToggle()
      .then((result) => {
        dispatch(updateFeatureToggle(result));
        dispatch(updateStatus(getFeatureToggleStatusName, Status.SUCCESS));
        if (cb_success) cb_success();
      })
      .catch((error) => {
        dispatch(updateStatus(getFeatureToggleStatusName, Status.FAILURE));
        console.error(error);
        if (cb_failed) cb_failed();
      });
  };
}

export function doPatchFeatureToggle(data, cb_success, cb_failed) {
  return (dispatch, getState) => {
    let patchFeatureToggleStatusName = 'PATCH-FeatureToggle';
    dispatch(updateStatus(patchFeatureToggleStatusName, Status.PENDING));

    patchFeatureToggle(data)
      .then((result) => {
        dispatch(updateFeatureToggle(data));
        dispatch(updateStatus(patchFeatureToggleStatusName, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(patchFeatureToggleStatusName, Status.FAILURE));
        console.error(error);
        if (cb_failed) cb_failed(error);
      });
  };
}

export function updateAutoUpdateSchedule(autoUpdateSchedule) {
  return {
    type: ActionTypes.UPDATE_AUTO_UPDATE_SCHEDULE,
    autoUpdateSchedule: autoUpdateSchedule
  };
}

export function doGetAutoUpdateSchedule(cb_success, cb_failed) {
  return (dispatch, getState) => {
    let getAutoUpdateScheduleStatusName = 'GET-AutoUpdateSchedule';
    dispatch(updateStatus(getAutoUpdateScheduleStatusName, Status.PENDING));

    getAutoUpdateSchedule()
      .then((result) => {
        if (result.scheduleText) {
          result.scheduleText = rephraseScheduleText(result.scheduleText);
        }
        dispatch(updateAutoUpdateSchedule(result));
        dispatch(updateStatus(getAutoUpdateScheduleStatusName, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(getAutoUpdateScheduleStatusName, Status.FAILURE));
        console.error(error);
        if (cb_failed) cb_failed(error);
      });
  };
}

export function doPostAutoUpdateSchedule(newAutoUpdateSchedule, cb_success, cb_failed) {
  return (dispatch, getState) => {
    let postAutoUpdateScheduleStatusName = 'POST-AutoUpdateSchedule';
    dispatch(updateStatus(postAutoUpdateScheduleStatusName, Status.PENDING));

    postAutoUpdateSchedule(newAutoUpdateSchedule)
      .then((result) => {
        // dispatch(updateAutoUpdateSchedule(newAutoUpdateSchedule));
        dispatch(updateStatus(postAutoUpdateScheduleStatusName, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(postAutoUpdateScheduleStatusName, Status.FAILURE));
        console.error(error);
        if (cb_failed) cb_failed(error);
      });
  };
}

export function updateProductTypesList(productTypesList) {
  return {
    type: ActionTypes.UPDATE_PRODUCT_TYPES_LIST,
    productTypesList: productTypesList
  };
}

//@todo use product type list to display/fetch any product type related component/data
export function doGetProductTypesList(cb_success, cb_failed) {
  return (dispatch) => {
    let getProductTypesListStatusName = 'GET-ProductTypesList';
    dispatch(updateStatus(getProductTypesListStatusName, Status.PENDING));

    getProductTypes()
      .then((res) => {
        dispatch(updateProductTypesList(res));
        dispatch(updateStatus(getProductTypesListStatusName, Status.SUCCESS));
        if (cb_success) cb_success(res);
      })
      .catch((e) => {
        dispatch(updateStatus(getProductTypesListStatusName, Status.FAILURE));
        console.error(e);
        if (cb_failed) cb_failed(e);
      });
  };
}

export function doPostDevicesAggregate(targetTab, body, cb_success, cb_failed) {
  return (dispatch, getState) => {
    let postDevicesAggregateStatusName = 'searchComponentFilteredDevicesV2_parametersGraph_' + targetTab;
    dispatch(updateStatus(postDevicesAggregateStatusName, Status.PENDING));

    postDevicesAggregate(body)
      .then((result) => {
        let filterRequestIndex = getState().data?.deviceSets?.deviceMap?.filterRequestIndex;
        filterRequestIndex !== null && filterRequestIndex++;
        dispatch(updateParameterGraphDeviceSet(targetTab, result, filterRequestIndex));
        dispatch(updateStatus(postDevicesAggregateStatusName, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(postDevicesAggregateStatusName, Status.FAILURE));
        console.error(error);
        if (cb_failed) cb_failed(error);
      });
  };
}

export function updateRasterRecord(deviceId, rasterId, record) {
  return {
    type: ActionTypes.UPDATE_RASTER_RECORD,
    deviceId,
    rasterId,
    record
  };
}

export function doGetRasterRecord(deviceId, rasterId, cb_success, cb_failed) {
  return (dispatch) => {
    let getRasterRecordStatusName = `GET-RasterRecord-${rasterId}`;
    let getAnyRasterRecordStatusName = 'GET-AnyRasterRecord';
    dispatch(updateStatus(getRasterRecordStatusName, Status.PENDING));
    dispatch(updateStatus(getAnyRasterRecordStatusName, Status.PENDING));

    getRasterRecord(deviceId, rasterId)
      .then(async (res) => {
        // below is just for colored heatmap testing
        // if (!res?.beamrank) {
        //   res.beamrank = HeatMapSampleData.beamrank;
        //   res.heatmap = HeatMapSampleData.heatmap;
        // }
        await dispatch(updateRasterRecord(deviceId, rasterId, res));
        dispatch(updateStatus(getRasterRecordStatusName, Status.SUCCESS));
        dispatch(updateStatus(getAnyRasterRecordStatusName, Status.SUCCESS));
        if (cb_success) cb_success(res);
      })
      .catch((e) => {
        dispatch(updateStatus(getRasterRecordStatusName, Status.FAILURE));
        dispatch(updateStatus(getAnyRasterRecordStatusName, Status.FAILURE));
        console.error(e);
        if (cb_failed) cb_failed(e);
      });
  };
}

export function updateSingleDevicePageSelectedRasterId(rasterId) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_RASTER_ID,
    selectedRasterId: rasterId
  };
}

export function updateSingleDevicePageSelectedDeviceHeatmapRowIdx(rowIdx) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_DEVICE_HEATMAP_ROW_IDX,
    rowIdx
  };
}

export function updateActionsPageTwoHopStatusInstanceDictionary(alignmentId, twoHopStatusInstanceDictionary) {
  return {
    type: ActionTypes.UPDATE_ACTIONS_PAGE_TWO_HOP_STATUS_INSTANCE_DICTIONARY,
    alignmentId,
    twoHopStatusInstanceDictionary
  };
}

export function updateActionsPageTwoHopProgressDictionary(alignmentId, twoHopProgressDictionary) {
  return {
    type: ActionTypes.UPDATE_ACTIONS_PAGE_TWO_HOP_PROGRESS_DICTIONARY,
    alignmentId,
    twoHopProgressDictionary
  };
}

export function updateActionsPageTwoHopRasterIdDictionary(alignmentId, twoHopRasterIdDictionary) {
  return {
    type: ActionTypes.UPDATE_ACTIONS_PAGE_TWO_HOP_RASTER_ID_DICTIONARY,
    alignmentId,
    twoHopRasterIdDictionary
  };
}

export function updateActionsPageTwoHopScoreDictionary(alignmentId, twoHopScoreDictionary) {
  return {
    type: ActionTypes.UPDATE_ACTIONS_PAGE_TWO_HOP_SCORE_DICTIONARY,
    alignmentId,
    twoHopScoreDictionary
  };
}

export function updateActionsPageSelectedRastersDictionary(alignmentId, twoHopSelectedRastersDictionary) {
  return {
    type: ActionTypes.UPDATE_ACTIONS_PAGE_TWO_HOP_SELECTED_RASTERS_DICTIONARY,
    twoHopSelectedRastersDictionary,
    alignmentId
  };
}

export function doGetTwoHopAlignmentStatusInstances(alignmentId, cb_success, cb_failed) {
  return (dispatch, getState) => {
    const prevTwoHopStatusInstanceDictionary =
      getState().ui.actionsPage?.twoHopStatusInstanceDictionary?.[alignmentId] ?? {};
    const getTwoHopAlignmentStatusInstancesName = `GET-TwoHopAlignmentStatusInstances-${alignmentId}`;
    dispatch(updateStatus(getTwoHopAlignmentStatusInstancesName, Status.PENDING));
    getTwoHopAlignmentStatusInstances(alignmentId)
      .then((res) => {
        const newTwoHopStatusInstanceDictionary = {};
        const newTwoHopProgressDictionary = {};
        const newTwoHopRasterIdDictionary = {};
        const newTwoHopScoreDictionary = {};
        res &&
          res.forEach((instance) => {
            newTwoHopStatusInstanceDictionary[instance.RowKey] = instance;
            newTwoHopProgressDictionary[instance.RowKey] = instance?.progress || 0;
            // newTwoHopProgressDictionary[instance.RowKey] = instance?.progress || (Math.random(0,1) * 100 > 50 ? 100 : (Math.random(0,1) * 100));
            newTwoHopRasterIdDictionary[instance.RowKey] =
              instance?.progress && instance?.rasterId !== 'unknown' ? instance.rasterId : null;
            newTwoHopScoreDictionary[instance.RowKey] = instance?.score;
            // newTwoHopScoreDictionary[instance.RowKey] = Math.random(0,1) * 100;
          });
        if (
          Object.keys(prevTwoHopStatusInstanceDictionary).length !==
          Object.keys(newTwoHopStatusInstanceDictionary).length
        ) {
          dispatch(updateActionsPageTwoHopStatusInstanceDictionary(alignmentId, newTwoHopStatusInstanceDictionary));
        }
        dispatch(updateActionsPageTwoHopProgressDictionary(alignmentId, newTwoHopProgressDictionary));
        dispatch(updateActionsPageTwoHopRasterIdDictionary(alignmentId, newTwoHopRasterIdDictionary));
        dispatch(updateActionsPageTwoHopScoreDictionary(alignmentId, newTwoHopScoreDictionary));
        dispatch(updateStatus(getTwoHopAlignmentStatusInstancesName, res?.length === 0 ? Status.NONE : Status.SUCCESS));
        if (cb_success) cb_success(res);
      })
      .catch((e) => {
        dispatch(updateStatus(getTwoHopAlignmentStatusInstancesName, Status.FAILURE));
        console.error(e);
        if (cb_failed) cb_failed(e);
      });
  };
}
export function doPostTwoHopAlignmentBeamInfo(alignmentId, body, cb_success, cb_failed) {
  return (dispatch) => {
    const postTwoHopAlignmentBeamInfoStatusName = `POST-TwoHopAlignmentBeamInfo-${alignmentId}`;
    dispatch(updateStatus(postTwoHopAlignmentBeamInfoStatusName, Status.PENDING));
    postTwoHopAlignmentBeamInfo(alignmentId, body)
      .then((res) => {
        if (res.success) {
          dispatch(updateActionsPageTwoHopRecBeamInfoDictionary(alignmentId, body));
        }
        dispatch(updateStatus(postTwoHopAlignmentBeamInfoStatusName, Status.SUCCESS));
        if (cb_success) cb_success(res);
      })
      .catch((e) => {
        dispatch(updateStatus(postTwoHopAlignmentBeamInfoStatusName, Status.FAILURE));
        console.error(e);
        if (cb_failed) cb_failed(e);
      });
  };
}

export function updateDeviceHeatmapHistoryDictionary(deviceId, deviceHeatmapHistoryDictionary) {
  return {
    type: ActionTypes.UPDATE_DEVICE_HEATMAP_HISTORY_DICTIONARY,
    deviceId,
    deviceHeatmapHistoryDictionary
  };
}

export function updateSingleDevicePageSelectedBeamRankIdx(index) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_BEAMRANK_IDX,
    index
  };
}

// export function updateDeviceHeatmapHistory(deviceId, deviceHeatmapHistory) {
//   return {
//     type: ActionTypes.UPDATE_DEVICE_HEATMAP_HISTORY,
//     deviceId,
//     deviceHeatmapHistory
//   };
// }

export function updateSingleDevicePageSelectedRastersDictionary(selectedRastersDictionary) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_RASTERS_DICTIONARY,
    selectedRastersDictionary
  };
}

export function updateSingleDevicePageHeatmapLibraryTableSetSelectAll(isSelected) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_HEATMAP_LIBRARY_TABLE_SET_SELECT_ALL,
    isSelected
  };
}

export function doGetRasterRecordsForDevice(deviceId, cb_success, cb_failed) {
  return (dispatch) => {
    let getRasterRecordsForDeviceStatusName = `GET-RasterRecordsForDevice-${deviceId}`;
    dispatch(updateStatus(getRasterRecordsForDeviceStatusName, Status.PENDING));

    getRasterRecordsForDevice(deviceId)
      .then((res) => {
        let deviceHeatmapHistoryDictionary = {};
        res &&
          res.forEach((record) => {
            if (record.rasterStatus !== 'fail') {
              deviceHeatmapHistoryDictionary[record.rasterId] = record;
            }
          });
        dispatch(updateDeviceHeatmapHistoryDictionary(deviceId, deviceHeatmapHistoryDictionary));
        // dispatch(updateDeviceHeatmapHistory(deviceId, res));
        dispatch(updateStatus(getRasterRecordsForDeviceStatusName, res?.length === 0 ? Status.NONE : Status.SUCCESS));
        if (cb_success) cb_success(res);
      })
      .catch((e) => {
        dispatch(updateStatus(getRasterRecordsForDeviceStatusName, Status.FAILURE));
        console.error(e);
        if (cb_failed) cb_failed(e);
      });
  };
}

export function doGetLatestHeatmapFromDevice(deviceId, cb_success, cb_failed, abortController) {
  return (dispatch) => {
    let getLatestHeatmapFromDeviceStatusName = `GET-LatestHeatmapFromDevice-${deviceId}`;
    dispatch(updateStatus(getLatestHeatmapFromDeviceStatusName, Status.PENDING));

    getLatestHeatmapFromDevice(deviceId, abortController)
      .then((res) => {
        if (res.ok === false) {
          console.log('res in error', res.status);
          if (cb_failed) cb_failed(res.status);
        } else {
          dispatch(updateStatus(getLatestHeatmapFromDeviceStatusName, Status.SUCCESS));
          if (cb_success) cb_success(res);
        }
      })
      .catch((e) => {
        dispatch(
          updateStatus(getLatestHeatmapFromDeviceStatusName, e.name === 'AbortError' ? Status.NONE : Status.FAILURE)
        );
        console.error(e);
        if (cb_failed) cb_failed(e.name === 'AbortError' ? 'Request Timed Out' : e);
      });
  };
}
const storeFactoryList = (factoryList) => ({ type: ActionTypes.UPDATE_FACTORY_LIST, factoryList });
const storeProtectedList = (protectedList) => ({ type: ActionTypes.UPDATE_PROTECTED_LIST, protectedList });

export function doGetProtectedList() {
  return (dispatch) => {
    dispatch(updateStatus('doGetProtectedList', Status.PENDING));
    getProtectedDevices()
      .then((res) => {
        dispatch(updateStatus('doGetProtectedList', Status.SUCCESS));
        dispatch(storeProtectedList(res));
      })
      .catch((e) => {
        dispatch(updateStatus('doGetProtectedList', Status.FAILURE));
      });
  };
}

export function doGetFactoryList() {
  return (dispatch) => {
    dispatch(updateStatus('doGetFactoryList', Status.PENDING));
    getFactoryProtectedDevices()
      .then((res) => {
        dispatch(updateStatus('doGetFactoryList', Status.SUCCESS));
        dispatch(storeFactoryList(res));
      })
      .catch((e) => {
        dispatch(updateStatus('doGetFactoryList', Status.FAILURE));
      });
  };
}

/**
 * add a list of devices to factory list
 * @param {list} deviceIds
 */
export function doAddFactoryDevices(deviceIds) {
  return (dispatch, getState) => {
    const cleanedDeviceIds = [];
    const factoryList = getState().data.factoryList;
    deviceIds.forEach((id) => {
      if (!factoryList.find((factoryDevice) => factoryDevice.deviceId === id)) {
        cleanedDeviceIds.push(id);
      }
    });

    cleanedDeviceIds.forEach((deviceId, index) => {
      dispatch(updateStatus(`doAddFactoryDevice-${index}`, Status.PENDING));
      addFactoryProtectedDevices(deviceId)
        .then((res) => {
          dispatch(updateStatus(`doAddFactoryDevice-${index}`, Status.SUCCESS));
          if (index === cleanedDeviceIds.length - 1) dispatch(doGetFactoryList());
        })
        .catch((e) => {
          dispatch(updateStatus(`doAddFactoryDevice-${index}`, Status.FAILURE));
        });
    });
  };
}

/**
 * delete all devices in the list from factory list
 * @param {list} deviceIds
 */
export function doDeleteFactoryDevices(deviceIds) {
  return (dispatch, getState) => {
    const cleanedDeviceIds = [];
    const factoryList = getState().data.factoryList;
    deviceIds.forEach((id) => {
      if (factoryList.find((factoryDevice) => factoryDevice.deviceId === id)) {
        cleanedDeviceIds.push(id);
      }
    });

    cleanedDeviceIds.forEach((deviceId, index) => {
      dispatch(updateStatus(`doDeleteFactoryDevice-${index}`, Status.PENDING));
      deleteFactoryProtectedDevice(deviceId)
        .then((res) => {
          dispatch(updateStatus(`doDeleteFactoryDevice-${index}`, Status.SUCCESS));
          if (index === cleanedDeviceIds.length - 1) dispatch(doGetFactoryList());
        })
        .catch((e) => {
          dispatch(updateStatus(`doDeleteFactoryDevice-${index}`, Status.FAILURE));
        });
    });
  };
}

/**
 * add a list of devices to protected list
 * @param {list} deviceIds
 */
export function doAddProtectedDevices(deviceIds) {
  return (dispatch, getState) => {
    const cleanedDeviceIds = [];
    const protectedList = getState().data.protectedList;
    deviceIds.forEach((id) => {
      if (!protectedList.find((protectedDevice) => protectedDevice.deviceId === id)) {
        cleanedDeviceIds.push(id);
      }
    });

    cleanedDeviceIds.forEach((deviceId, index) => {
      dispatch(updateStatus(`doAddProtectedDevice-${index}`, Status.PENDING));
      addProtectedDevice(deviceId)
        .then((res) => {
          dispatch(updateStatus(`doAddProtectedDevice-${index}`, Status.SUCCESS));
          if (index === cleanedDeviceIds.length - 1) dispatch(doGetProtectedList());
        })
        .catch((e) => {
          dispatch(updateStatus(`doAddProtectedDevice-${index}`, Status.FAILURE));
        });
    });
  };
}

/**
 * delete all devices in the list from protected list
 * @param {list} deviceIds
 */
export function doDeleteProtectedDevices(deviceIds) {
  return (dispatch, getState) => {
    const cleanedDeviceIds = [];
    const protectedList = getState().data.protectedList;
    deviceIds.forEach((id) => {
      if (protectedList.find((protectedDevice) => protectedDevice.deviceId === id)) {
        cleanedDeviceIds.push(id);
      }
    });

    cleanedDeviceIds.forEach((deviceId, index) => {
      dispatch(updateStatus(`doDeleteProtectedDevice-${index}`, Status.PENDING));
      deleteProtectedDevice(deviceId)
        .then((res) => {
          dispatch(updateStatus(`doDeleteProtectedDevice-${index}`, Status.SUCCESS));
          if (index === cleanedDeviceIds.length - 1) dispatch(doGetProtectedList());
        })
        .catch((e) => {
          dispatch(updateStatus(`doDeleteProtectedDevice-${index}`, Status.FAILURE));
        });
    });
  };
}

export function doPersistRasterRecord(persistUri, deviceId, cb_success, cb_failed) {
  return (dispatch) => {
    let persistRasterRecordStatusName = `PATCH-PersistRasterRecord-${deviceId}`;
    dispatch(updateStatus(persistRasterRecordStatusName, Status.PENDING));

    persistRasterRecord(persistUri)
      .then((res) => {
        if (res.ok === false) {
          console.log('res in error', res.status);
          if (cb_failed) cb_failed(res.status);
        } else {
          dispatch(updateStatus(persistRasterRecordStatusName, Status.SUCCESS));
          if (cb_success) cb_success(res);
        }
      })
      .catch((e) => {
        console.error(e);
        if (cb_failed) cb_failed(e);
      });
  };
}

export function setLastScroll(value, component, activeTab) {
  return {
    type: ActionTypes.SET_LAST_SCROLL,
    component,
    value,
    activeTab
  };
}

export function doInitiateRaster(deviceId, body, cb_success, cb_failed, abortController) {
  return (dispatch) => {
    let initiateRasterStatusName = `POST-InitiateRaster-${deviceId}`;
    dispatch(updateStatus(initiateRasterStatusName, Status.PENDING));

    initiateRaster(deviceId, body, abortController)
      .then((res) => {
        if (res.ok === false) {
          console.log('res in error', res.status);
          if (cb_failed) cb_failed(res.status);
        } else {
          dispatch(updateStatus(initiateRasterStatusName, Status.SUCCESS));
          if (cb_success) cb_success(res);
        }
      })
      .catch((e) => {
        dispatch(updateStatus(initiateRasterStatusName, e.name === 'AbortError' ? Status.NONE : Status.FAILURE));
        console.error(e);
        if (cb_failed) cb_failed(e.name === 'AbortError' ? 'Request Timed Out' : e);
      });
  };
}

export function setDeviceTableWidth(deviceTableWidth) {
  return {
    type: ActionTypes.UI_SET_DEVICETABLE_WIDTH,
    deviceTableWidth
  };
}

export function updateSingleDevicePageSelectedRasterRecord(record) {
  return {
    type: ActionTypes.UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_RASTER_RECORD,
    record
  };
}

export function doGetTwoHopAlignmentBeamInfo(alignmentId, cb_success, cb_failed) {
  return (dispatch) => {
    const getTwoHopAlignmentBeamInfoStatusName = `GET-TwoHopAlignmentBeamInfo-${alignmentId}`;
    dispatch(updateStatus(getTwoHopAlignmentBeamInfoStatusName, Status.PENDING));

    getTwoHopAlignmentBeamInfo(alignmentId)
      .then((res) => {
        dispatch(updateActionsPageTwoHopRecBeamInfoDictionary(alignmentId, res));
        dispatch(updateStatus(getTwoHopAlignmentBeamInfoStatusName, Status.SUCCESS));
        if (cb_success) cb_success(res);
      })
      .catch((e) => {
        dispatch(updateStatus(getTwoHopAlignmentBeamInfoStatusName, Status.FAILURE));
        console.error(e);
        if (cb_failed) cb_failed(e);
      });
  };
}

export function doCancelTwoHopAlignment(actionType, alignmentId, cb_success, cb_failed) {
  return (dispatch) => {
    const cancelTwoHopAlignmentStatusName = `POST-CancelTwoHopAlignment-${alignmentId}-${actionType}`;
    dispatch(updateStatus(cancelTwoHopAlignmentStatusName, Status.PENDING));

    const requestBody = { action: actionType, id: alignmentId };
    cancelTwoHopAlignment(requestBody)
      .then((res) => {
        dispatch(updateStatus(cancelTwoHopAlignmentStatusName, Status.SUCCESS));
        actionType === 'get' && dispatch(updateActionsPageTwoHopCancelStatusDictionary(alignmentId, res));
        if (cb_success) cb_success(res);
      })
      .catch((e) => {
        dispatch(updateStatus(cancelTwoHopAlignmentStatusName, Status.FAILURE));
        console.error(e);
        if (cb_failed) cb_failed(e);
      });
  };
}

export function updateActionsPageTwoHopRecBeamInfoDictionary(alignmentId, twoHopRecBeamInfoDictionary) {
  return {
    type: ActionTypes.UPDATE_ACTIONS_PAGE_TWO_HOP_REC_BEAM_INFO_DICTIONARY,
    alignmentId,
    twoHopRecBeamInfoDictionary
  };
}

export function updateActionsPageTwoHopCancelStatusDictionary(alignmentId, cancelStatusObj) {
  return {
    type: ActionTypes.UPDATE_ACTIONS_PAGE_TWO_HOP_CANCEL_STATUS_DICTIONARY,
    alignmentId,
    cancelStatusObj
  };
}

export function updatePivotOverviewPageSelectedDevices(devices) {
  return {
    type: ActionTypes.UI_PIVOT_OVERVIEW_PAGE_UPDATE_SELECTED_DEVICES,
    devices
  };
}

export function updatePivotOverviewPageSingleSelectedDevice(device) {
  return {
    type: ActionTypes.UI_PIVOT_OVERVIEW_PAGE_UPDATE_SINGLE_SELECTED_DEVICE,
    device
  };
}

export function updatePivotOverviewPageActiveTab(deviceId) {
  return {
    type: ActionTypes.UI_PIVOT_OVERVIEW_PAGE_UPDATE_ACTIVE_TAB,
    deviceId
  };
}

export function updatePivotOverviewPageRfConfigActionStatus(deviceId, status) {
  return {
    type: ActionTypes.UI_PIVOT_OVERVIEW_PAGE_UPDATE_RF_CONFIG_ACTION_STATUS,
    deviceId,
    status
  };
}

export function updateEchoOverviewPageSelectedDevice(device) {
  return {
    type: ActionTypes.UI_ECHO_OVERVIEW_PAGE_UPDATE_SELECTED_DEVICE,
    device
  };
}

export function updateChartExplorerPageSelectedDeviceId(deviceId) {
  return {
    type: ActionTypes.UI_CHART_EXPLORER_PAGE_UPDATE_SELECTED_DEVICE_ID,
    deviceId
  };
}

export function setChartSet(preference) {
  const preferenceId = typeof preference === 'string' ? preference : preference?.preferenceId;

  return {
    type: ActionTypes.UI_CHART_SET_SELECT,
    payload: {},
    meta: { preferenceId }
  };
}

export function updateChartSet(preference) {
  const { preferenceId, state } = preference;

  return {
    type: ActionTypes.UI_CHART_SET_UPDATE,
    payload: state,
    meta: { preferenceId }
  };
}

export function doStoreRasterSettings(data) {
  return {
    type: ActionTypes.GET_RASTER_SETTINGS,
    data
  };
}

export function doGetRasterSettings(cb_success, cb_failed) {
  return (dispatch) => {
    const getRasterSettingsStatusName = `GET-RasterSettings`;
    dispatch(updateStatus(getRasterSettingsStatusName, Status.PENDING));

    getRasterSettings()
      .then((res) => {
        dispatch(doStoreRasterSettings(res));
        dispatch(updateStatus(getRasterSettingsStatusName, Status.SUCCESS));
        if (cb_success) cb_success(res);
      })
      .catch((e) => {
        dispatch(updateStatus(getRasterSettingsStatusName, Status.FAILURE));
        console.error(e);
        if (cb_failed) cb_failed(e);
      });
  };
}

export function loadUserPreferences() {
  return async (dispatch, getState) => {
    await dispatch(getUserPreferenceList());

    const state = getState();
    const activeTab = selectActiveTabName(state);
    const userPreferences = selectUserPreferences(state);
    const userColumnPreferences = selectUserPreferenceList(userPreferences, USER_PREFERENCE_SETS.COLUMNS_SET);
    const defaultUserFilterPreference = selectDefaultUserPreference(userPreferences, USER_PREFERENCE_SETS.FILTER_SET);

    const activeFilterSetId = state.ui.devicesPage.activeFilterSetId;
    const activeFilterSet = selectUserPreference(userPreferences, activeFilterSetId);

    dispatch(
      updateActiveFilterPreference(activeFilterSet?.preferenceId ?? defaultUserFilterPreference?.preferenceId ?? '')
    );

    if (activeFilterSet) {
      dispatch(parseAllSearchFilters(activeTab, getParsedFilterSet(activeFilterSet.state), true, true));
    } else if (defaultUserFilterPreference) {
      dispatch(parseAllSearchFilters(activeTab, getParsedFilterSet(defaultUserFilterPreference.state), true, true));
    }

    if (userColumnPreferences.length === 0) {
      try {
        await dispatch(createUserPreference(generateDefaultTabColumnsPreferenceReqBody()));
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(error);
        }
      }
    } else {
      const { preferenceId, state, category, name } = userColumnPreferences[0];

      const defaultColumnPreferences = generateDefaultTabColumnsPreferenceReqBody();

      if (!hasColumnStateChanged(defaultColumnPreferences.state, state)) return;

      const syncedState = syncColumnStates(defaultColumnPreferences.state, state);

      const payload = {
        preferenceId,
        category,
        name,
        default: false,
        state: syncedState
      };

      dispatch(patchUserPreference(payload));
    }
  };
}
